(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evergreen-cinematic-stage"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const aero=root.querySelector('[data-scene="aero"]'),uat=root.querySelector('[data-scene="uat"]'),canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d',{alpha:false}),uatCanvas=root.querySelector('[data-uat-atmosphere]'),uatCtx=uatCanvas.getContext('2d'),photo=root.querySelector('.ev-scene__poster'),video=root.querySelector('video'),toggle=root.querySelector('[data-motion-toggle]'),mq=matchMedia('(prefers-reduced-motion: reduce)');
  const intro=aero.querySelector('.ev-scene__intro'),outro=aero.querySelector('.ev-scene__outro'),looks=[...root.querySelectorAll('[data-look]')],chapters=[...root.querySelectorAll('.ev-uat__chapters span')],labels=root.querySelector('[data-labels]').dataset.labels.split('|');
  let enabled=!mq.matches&&!navigator.connection?.saveData,visible=false,aeroVisible=true,uatVisible=false,raf=0,last=0,elapsed=0,w=0,h=0,dpr=1,p=0,q=0,seekTarget=0,disposed=false,texture=null;
  const clamp=n=>Math.max(0,Math.min(1,n)),smooth=(a,b,v)=>{const x=clamp((v-a)/(b-a));return x*x*(3-2*x)};
  const seed=(n)=>{const x=Math.sin(n*127.1+311.7)*43758.5453;return x-Math.floor(x)};
  const smoke=()=>{const c=document.createElement('canvas');c.width=192;c.height=96;const x=c.getContext('2d'),im=x.createImageData(192,96);const noise=(a,b)=>{let v=0,amp=.5;for(let o=0;o<4;o++){const k=2**o,xx=a*k,yy=b*k,ix=Math.floor(xx),iy=Math.floor(yy),fx=smooth(0,1,xx-ix),fy=smooth(0,1,yy-iy);v+=amp*((seed(ix+iy*59)*(1-fx)+seed(ix+1+iy*59)*fx)*(1-fy)+(seed(ix+(iy+1)*59)*(1-fx)+seed(ix+1+(iy+1)*59)*fx)*fy);amp*=.5}return v};for(let j=0;j<96;j++)for(let i=0;i<192;i++){const a=(j*192+i)*4,dx=(i-96)/96,dy=(j-48)/48,fall=Math.max(0,1-dx*dx-dy*dy);im.data[a]=192;im.data[a+1]=211;im.data[a+2]=221;im.data[a+3]=Math.max(0,noise(i/25,j/20)-.23)*fall*170}x.putImageData(im,0,0);return c};
  const resize=()=>{const r=aero.querySelector('.ev-scene__sticky').getBoundingClientRect();w=r.width;h=r.height;dpr=Math.min(devicePixelRatio||1,1.5);canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr);ctx?.setTransform(dpr,0,0,dpr,0,0);const ur=uat.querySelector('.ev-scene__sticky').getBoundingClientRect();uatCanvas.width=Math.round(ur.width*dpr);uatCanvas.height=Math.round(ur.height*dpr);uatCtx?.setTransform(dpr,0,0,dpr,0,0);update();draw()};
  const progress=el=>{const r=el.getBoundingClientRect();return clamp(-r.top/Math.max(1,r.height-el.querySelector('.ev-scene__sticky').offsetHeight))};
  const seek=()=>{if(!video||!enabled||video.readyState<2||!Number.isFinite(video.duration)||video.seeking)return;if(Math.abs(video.currentTime-seekTarget)>.035)video.currentTime=seekTarget};
  const update=()=>{const ar=aero.getBoundingClientRect();aeroVisible=root.dataset.scenes!=='uat'&&ar.bottom>0&&ar.top<innerHeight;const ur=uat.getBoundingClientRect();uatVisible=root.dataset.scenes!=='aero'&&ur.bottom>0&&ur.top<innerHeight;aero.style.setProperty('--clearance',Math.max(0,Math.min(ar.top,innerHeight/3))+'px');p=enabled?progress(aero):0;q=enabled?progress(uat):0;aero.style.setProperty('--progress',p);uat.style.setProperty('--progress',q);const a=1-smooth(.12,.34,p),b=smooth(.53,.72,p);intro.style.opacity=a;intro.style.transform=`translateY(${-p*55}px)`;intro.style.visibility=a<.01?'hidden':'visible';outro.style.opacity=b;outro.style.transform=`translateY(${(1-b)*30}px)`;outro.style.pointerEvents=b>.7?'auto':'none';outro.style.visibility=b<.01?'hidden':'visible';const l1=smooth(.48,.68,q),l2=smooth(.76,.96,q);looks[0].style.opacity=l1;looks[0].style.clipPath='none';looks[0].style.transform=`scale(${1.065-.065*l1})`;looks[0].style.filter=`blur(${(1-l1)*7}px)`;looks[1].style.opacity=l2;looks[1].style.clipPath='none';looks[1].style.transform=`scale(${1.065-.065*l2})`;looks[1].style.filter=`blur(${(1-l2)*7}px)`;root.querySelector('.ev-uat__poster').style.opacity=1-l1;if(video)video.style.opacity=root.dataset.videoReady?(1-l1):0;const active=q<.58?0:q<.86?1:2;chapters.forEach((c,i)=>c.toggleAttribute('data-active',i===active));root.querySelector('[data-uat-label]').textContent=labels[active];if(video&&Number.isFinite(video.duration)){seekTarget=clamp(q/.46)*Math.max(0,video.duration-.08);seek()}};
  const fog=(ox,oy,scale,alpha,phase)=>{ctx.save();ctx.globalAlpha=alpha;ctx.globalCompositeOperation='screen';for(let i=0;i<6;i++){const drift=((elapsed*9+phase+i*231)%(w+700))-350;ctx.drawImage(texture,drift+ox,oy+Math.sin(i*2+elapsed*.13)*18,w*.60*scale,h*.20*scale)}ctx.restore()};
  const drawUat=()=>{if(!uatCtx)return;const uw=uatCanvas.width/dpr,uh=uatCanvas.height/dpr;uatCtx.clearRect(0,0,uw,uh);if(!enabled||!uatVisible)return;if(!texture)texture=smoke();uatCtx.save();uatCtx.globalCompositeOperation='screen';for(let layer=0;layer<3;layer++){uatCtx.globalAlpha=.72+layer*.12;for(let j=0;j<5;j++){const xx=((elapsed*(20+layer*12)+j*uw*.48+layer*71)%(uw*2))-uw*.7;const yy=uh*(.54+layer*.12)+Math.sin(elapsed*.17+j)*uh*.03;uatCtx.drawImage(texture,xx,yy,uw*1.05,uh*.43)}}uatCtx.globalAlpha=1;for(let j=0;j<7;j++){const xx=((elapsed*150+j*210)%(uw+850))-500,yy=uh*(.42+seed(j+30)*.44);const gr=uatCtx.createLinearGradient(xx,0,xx+600,0);gr.addColorStop(0,'rgba(224,239,244,0)');gr.addColorStop(.5,'rgba(224,239,244,.23)');gr.addColorStop(1,'rgba(224,239,244,0)');uatCtx.strokeStyle=gr;uatCtx.lineWidth=1.3+j%3;uatCtx.beginPath();uatCtx.moveTo(xx,yy);uatCtx.bezierCurveTo(xx+180,yy-55,xx+390,yy+18,xx+600,yy-75);uatCtx.stroke()}uatCtx.restore()};
  const draw=()=>{drawUat();if(!aeroVisible&&enabled)return;if(!ctx||!photo.complete||!photo.naturalWidth||!w)return;ctx.fillStyle='#070a0d';ctx.fillRect(0,0,w,h);const mobile=w<750,zoom=1+(enabled?p*(mobile?.025:.065):0),s=(mobile?h/photo.naturalHeight*.70:Math.max(w/photo.naturalWidth,h/photo.naturalHeight))*zoom,iw=photo.naturalWidth*s,ih=photo.naturalHeight*s,x=(w-iw)/2,y=mobile?h*.08:(h-ih)/2;ctx.drawImage(photo,x,y,iw,ih);if(mobile){const edge=ctx.createLinearGradient(0,y,0,y+ih);edge.addColorStop(0,'#080b0e');edge.addColorStop(.1,'#080b0e00');edge.addColorStop(.82,'#080b0e00');edge.addColorStop(1,'#080b0e');ctx.fillStyle=edge;ctx.fillRect(0,y,w,ih)}if(!enabled)return;if(!texture)texture=smoke();const sx=n=>x+iw*n,sy=n=>y+ih*n;ctx.save();ctx.globalCompositeOperation='screen';for(const nx of [.18,.66,.89]){const gx=sx(nx),gy=sy(.61),g=ctx.createRadialGradient(gx,gy,0,gx,gy,Math.min(w,h)*.40);g.addColorStop(0,'rgba(156,203,234,.15)');g.addColorStop(1,'rgba(125,181,213,0)');ctx.fillStyle=g;ctx.fillRect(0,0,w,h)}ctx.restore();fog(-70,sy(.68),.8,.22,40);ctx.save();ctx.globalAlpha=smooth(.12,.38,p)*(1-smooth(.43,.61,p))*.66;ctx.fillStyle='#dce6eb';ctx.textAlign='center';ctx.font=`300 ${Math.min(w*.27,380)}px Arial`;ctx.fillText('AERO',w/2,h*.52);ctx.restore();ctx.save();ctx.beginPath();const points=[[.49,.055],[.513,.061],[.532,.088],[.532,.14],[.523,.18],[.554,.227],[.577,.365],[.586,.503],[.574,.578],[.553,.594],[.55,.678],[.549,.775],[.541,.824],[.532,.875],[.542,.92],[.531,.947],[.507,.95],[.496,.917],[.501,.84],[.49,.739],[.47,.63],[.46,.73],[.456,.827],[.464,.89],[.457,.92],[.431,.92],[.426,.89],[.433,.829],[.439,.724],[.431,.611],[.431,.568],[.413,.555],[.42,.478],[.421,.348],[.435,.23],[.473,.18],[.472,.138],[.477,.082]];points.forEach(([a,b],i)=>i?ctx.lineTo(sx(a),sy(b)):ctx.moveTo(sx(a),sy(b)));ctx.closePath();ctx.clip();ctx.drawImage(photo,x,y,iw,ih);ctx.restore();fog(0,sy(.83),1,.16,360);ctx.save();ctx.globalCompositeOperation='screen';for(let j=0;j<10;j++){const flow=((elapsed*105+j*193)%(w+900))-450,yy=h*(.32+seed(j+440)*.58);const g=ctx.createLinearGradient(flow,0,flow+420,0);g.addColorStop(0,'rgba(190,220,231,0)');g.addColorStop(.5,'rgba(190,220,231,.12)');g.addColorStop(1,'rgba(190,220,231,0)');ctx.strokeStyle=g;ctx.lineWidth=1+seed(j)*2;ctx.beginPath();ctx.moveTo(flow,yy+28);ctx.bezierCurveTo(flow+130,yy-23,flow+270,yy+8,flow+420,yy-45);ctx.stroke()}ctx.restore();ctx.save();ctx.lineCap='round';for(let layer=0;layer<3;layer++){const count=mobile?9:14;for(let i=0;i<count;i++){const id=i+layer*103,depth=(layer+1)/3,xx=(seed(id)*w+elapsed*72*(.6+depth))%(w+40)-20,yy=(seed(id+800)*(h+60)+elapsed*(330+depth*440))%(h+70)-35;ctx.strokeStyle=`rgba(203,223,234,${.09+depth*.13})`;ctx.lineWidth=.45+depth*1.1;ctx.beginPath();ctx.moveTo(xx,yy);ctx.lineTo(xx+3+depth*6,yy+10+depth*23);ctx.stroke()}}ctx.restore();for(let j=0;j<(mobile?4:7);j++){const r=4+seed(j+90)*6,dx=w*(.07+seed(j+14)*.86)+Math.sin(elapsed*.33+j)*3,dy=((seed(j+70)*(h+150)+elapsed*(15+seed(j+3)*19))%(h+150))-75;ctx.save();const trail=ctx.createLinearGradient(dx,dy-r*8,dx,dy);trail.addColorStop(0,'rgba(231,241,248,0)');trail.addColorStop(1,'rgba(231,241,248,.18)');ctx.strokeStyle=trail;ctx.lineWidth=1.3;ctx.beginPath();ctx.moveTo(dx-2,dy-r*8);ctx.bezierCurveTo(dx+3,dy-r*5,dx-2,dy-r*2,dx,dy);ctx.stroke();ctx.beginPath();ctx.ellipse(dx,dy,r*.67,r*1.45,.08,0,Math.PI*2);ctx.clip();const sw=r*2/s,sh=r*3.2/s,px=(dx-x)/s-sw/2,py=(dy-y)/s-sh/2;if(px>0&&py>0&&px+sw<photo.naturalWidth&&py+sh<photo.naturalHeight)ctx.drawImage(photo,px,py,sw,sh,dx-r,dy-r*1.6,r*2,r*3.2);const g=ctx.createRadialGradient(dx-r*.3,dy-r*.5,0,dx,dy,r*1.6);g.addColorStop(0,'rgba(241,249,255,.48)');g.addColorStop(.25,'rgba(217,231,242,.08)');g.addColorStop(.7,'rgba(4,12,20,.24)');g.addColorStop(1,'rgba(207,229,240,.55)');ctx.fillStyle=g;ctx.fillRect(dx-r,dy-r*1.6,r*2,r*3.2);ctx.restore();ctx.beginPath();ctx.ellipse(dx,dy,r*.67,r*1.45,.08,0,Math.PI*2);ctx.strokeStyle='rgba(222,238,247,.24)';ctx.lineWidth=.7;ctx.stroke()}if(!root.dataset.canvasReady)root.dataset.canvasReady='true'};
  const frame=t=>{raf=0;if(disposed||!enabled||!visible||!(aeroVisible||uatVisible)||document.hidden)return;const dt=last?Math.min((t-last)/1000,.05):0;last=t;elapsed+=dt;draw();raf=requestAnimationFrame(frame)};
  const start=()=>{if(!raf&&enabled&&visible&&(aeroVisible||uatVisible)&&!document.hidden){last=0;raf=requestAnimationFrame(frame)}};
  const scroll=()=>{update();start()};
  const loadVideo=()=>{if(!enabled||!video||root.dataset.scenes==='aero')return;const r=uat.getBoundingClientRect();if(r.top>innerHeight+800||r.bottom < -800)return;const source=video.querySelector('source');if(!source.src){source.src=source.dataset.src;video.load()}};
  const mode=(broadcast=true)=>{root.toggleAttribute('data-motion',enabled);root.toggleAttribute('data-static',!enabled);if(toggle){toggle.setAttribute('aria-pressed',String(!enabled));toggle.textContent=enabled?toggle.dataset.off:toggle.dataset.on;}if(!enabled){cancelAnimationFrame(raf);raf=0;video?.pause()}resize();loadVideo();start();if(broadcast)document.dispatchEvent(new CustomEvent('ev:motion-mode',{detail:{enabled}}))};
  const shared=e=>{if(enabled!==e.detail.enabled){enabled=e.detail.enabled;mode(false)}};document.addEventListener('ev:motion-mode',shared);
  const toggleMode=()=>{enabled=!enabled;mode()};toggle?.addEventListener('click',toggleMode);
  const change=()=>{enabled=!mq.matches;mode()};mq.addEventListener('change',change);
  const visibility=()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0}else start()};document.addEventListener('visibilitychange',visibility);
  const observer=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);if(visible)start();else{cancelAnimationFrame(raf);raf=0}},{rootMargin:'200px'});observer.observe(root);
  const preload=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))loadVideo()},{rootMargin:'800px'});preload.observe(uat);
  const videoReady=()=>{root.dataset.videoReady='true';update()};video?.addEventListener('loadeddata',videoReady);video?.addEventListener('seeked',seek);video?.addEventListener('error',()=>{delete root.dataset.videoReady});
  const ro=new ResizeObserver(resize);ro.observe(aero.querySelector('.ev-scene__sticky'));photo.addEventListener('load',resize);window.addEventListener('scroll',scroll,{passive:true});
  root.querySelectorAll('a[href="#ev-shop"]').forEach(a=>a.addEventListener('click',e=>{const target=document.querySelector('.eh-shop');if(target){e.preventDefault();target.scrollIntoView({block:'start',behavior:'instant'});target.querySelector('a')?.focus({preventScroll:true})}}));
  const cleanup=e=>{if(e.target.contains(root)){disposed=true;cancelAnimationFrame(raf);observer.disconnect();preload.disconnect();ro.disconnect();window.removeEventListener('scroll',scroll);document.removeEventListener('visibilitychange',visibility);document.removeEventListener('ev:motion-mode',shared);mq.removeEventListener('change',change);document.removeEventListener('shopify:section:unload',cleanup)}};document.addEventListener('shopify:section:unload',cleanup);mode();
 };document.querySelectorAll('[data-ev-cinema]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ev-cinema]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-editorial-chapter"] && !Shopify.designMode) return;
  try {
    
  (()=>{const media=matchMedia('(prefers-reduced-motion: reduce)');const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';if(!root.classList.contains('ec--look'))return;let raf=0,visible=false;const draw=()=>{raf=0;if(media.matches||!visible)return;const rect=root.getBoundingClientRect(),p=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));root.style.setProperty('--ec-zoom',1.12-p*.12)};const tick=()=>{if(!raf&&visible)raf=requestAnimationFrame(draw)};const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;tick()});observer.observe(root);window.addEventListener('scroll',tick,{passive:true});const cleanup=e=>{if(e.target.contains(root)){observer.disconnect();cancelAnimationFrame(raf);window.removeEventListener('scroll',tick);document.removeEventListener('shopify:section:unload',cleanup)}};document.addEventListener('shopify:section:unload',cleanup)};document.querySelectorAll('[data-ec-chapter]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ec-chapter]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const media=matchMedia('(prefers-reduced-motion: reduce)'),toggle=root.querySelector('[data-ev-toggle]');let enabled=!media.matches,raf=0;const clamp=n=>Math.max(0,Math.min(1,n));const draw=()=>{raf=0;if(!enabled)return;const r=root.getBoundingClientRect(),p=clamp(-r.top/Math.max(1,r.height-innerHeight));root.style.setProperty('--ev-scale',1+p*.16);root.style.setProperty('--ev-inset',`${p*3}%`);root.style.setProperty('--ev-radius',`${p*16}px`);root.style.setProperty('--ev-type-shift',`${-p*innerWidth*.15}px`);root.style.setProperty('--ev-copy',1-clamp((p-.45)/.5));};const tick=()=>{if(!raf&&enabled)raf=requestAnimationFrame(draw)};const mode=()=>{root.toggleAttribute('data-motion',enabled);toggle.setAttribute('aria-pressed',String(!enabled));toggle.textContent=enabled?toggle.dataset.off:toggle.dataset.on;tick()};toggle.addEventListener('click',()=>{enabled=!enabled;mode()});const change=()=>{enabled=!media.matches;mode()};media.addEventListener('change',change);root.querySelector('[data-ev-shop]').addEventListener('click',e=>{const shop=document.querySelector('.eh-shop');if(shop){e.preventDefault();shop.scrollIntoView({block:'start',behavior:'instant'});shop.querySelector('a')?.focus({preventScroll:true})}});window.addEventListener('scroll',tick,{passive:true});window.addEventListener('resize',tick,{passive:true});const cleanup=e=>{if(e.target.contains(root)){cancelAnimationFrame(raf);window.removeEventListener('scroll',tick);window.removeEventListener('resize',tick);media.removeEventListener('change',change);document.removeEventListener('shopify:section:unload',cleanup)}};document.addEventListener('shopify:section:unload',cleanup);mode()};document.querySelectorAll('[data-ev-hero]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ev-hero]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-fabric-explosion"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';const canvas=root.querySelector('canvas'),gl=canvas.getContext('webgl',{alpha:true,antialias:true,powerPreference:'low-power'}),stage=root.querySelector('.ev-fabric__stage'),copies=[...root.querySelectorAll('[data-fabric-copy]')],buttons=[...root.querySelectorAll('[data-fabric-target]')],toggle=root.querySelector('[data-fabric-toggle]'),mq=matchMedia('(prefers-reduced-motion: reduce)');let enabled=!mq.matches&&!navigator.connection?.saveData,p=0,manual=-1,manualY=0,raf=0,visible=false,disposed=false,program=null,locations={},buffers=[],width=0,height=0;
 const clamp=x=>Math.max(0,Math.min(1,x)),smooth=(a,b,x)=>{const t=clamp((x-a)/(b-a));return t*t*(3-2*t)};
 const vertex=`attribute vec3 a_position;attribute vec2 a_uv;uniform float u_layer;uniform float u_spread;uniform float u_turn;uniform float u_focus;uniform float u_aspect;uniform float u_mobile;varying vec2 v_uv;varying vec3 v_normal;varying vec3 v_pos;void main(){vec3 q=a_position;float wave=sin(q.x*1.7+q.z*1.4)*.14+sin(q.z*2.3)*.09;q.y=a_position.y+wave+(1.0-u_layer)*u_spread;float tilt=.23+u_turn*.18;mat3 ry=mat3(cos(tilt),0.,-sin(tilt),0.,1.,0.,sin(tilt),0.,cos(tilt));float pitch=.64;mat3 rx=mat3(1.,0.,0.,0.,cos(pitch),sin(pitch),0.,-sin(pitch),cos(pitch));vec3 normal=normalize(vec3(-cos(q.x*1.7+q.z*1.4)*.17,1.,-cos(q.x*1.7+q.z*1.4)*.14-cos(q.z*2.3)*.161));q=rx*ry*q;v_normal=rx*ry*normal;v_uv=a_uv;v_pos=q;float perspective=4.6/(4.6-q.z);float zoom=mix(.83,.28,u_mobile)+u_focus*mix(.10,.025,u_mobile);q.xy*=perspective*zoom;q.x/=u_aspect;q.x+=mix(.37,0.,u_mobile);q.y+=mix(.06,.62,u_mobile);gl_Position=vec4(q.x,q.y,-q.z*.10,1.);}`;
 const fragment=`precision highp float;varying vec2 v_uv;varying vec3 v_normal;varying vec3 v_pos;uniform float u_layer;uniform float u_active;float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}void main(){vec2 uv=v_uv;vec3 base;float pattern;float warp=sin(uv.x*420.)*.5+.5;float weft=sin(uv.y*420.)*.5+.5;if(u_layer<.5){pattern=.73+.27*warp*weft;base=vec3(.22,.29,.34);}else if(u_layer<1.5){pattern=.92+.08*hash(floor(uv*500.));base=vec3(.48,.65,.69);}else{vec2 cell=fract(uv*vec2(75.,62.));float loop=abs(length((cell-vec2(.5,.37))*vec2(1.1,.78))-.28);float yarn=1.-smoothstep(.045,.12,loop);float stem=exp(-pow((cell.x-.5-sin(cell.y*6.28)*.16)*18.,2.));pattern=.62+.26*yarn+.12*stem;base=vec3(.58,.61,.60);}vec3 n=normalize(v_normal+vec3(sin(uv.x*420.)*.055,0.,cos(uv.y*420.)*.055));float light=.32+.68*max(0.,dot(n,normalize(vec3(-.5,1.,1.))));float spec=pow(max(0.,dot(reflect(-normalize(vec3(-.5,1.,1.)),n),normalize(vec3(0.,0.,1.)))),26.);float edge=smoothstep(.014,0.,min(min(uv.x,1.-uv.x),min(uv.y,1.-uv.y)));float active=mix(.55,1.,u_active);vec3 color=base*pattern*light*active+spec*.20+vec3(.65,.82,.91)*edge*.09;if(u_layer<.5){for(int i=0;i<9;i++){float fi=float(i);vec2 c=vec2(.13+hash(vec2(fi,3.))*.73,.17+hash(vec2(fi,7.))*.66);vec2 d=(uv-c)*vec2(1.,.76);float radius=.016+hash(vec2(fi,2.))*.012;float dist=length(d);float bead=1.-smoothstep(radius-.002,radius,dist);float rim=smoothstep(radius*.6,radius,dist)*bead;float shine=pow(max(0.,1.-length(d/radius-vec2(-.32,.3))),5.);color=mix(color,color*.62+vec3(.75,.88,.94)*(rim*.56+shine*.9),bead);}}gl_FragColor=vec4(color,1.);}`;
 const shader=(type,src)=>{const sh=gl.createShader(type);gl.shaderSource(sh,src);gl.compileShader(sh);if(!gl.getShaderParameter(sh,gl.COMPILE_STATUS)){gl.deleteShader(sh);throw new Error('Fabric shader compile failed')}return sh};
 if(gl){try{program=gl.createProgram();const vs=shader(gl.VERTEX_SHADER,vertex),fs=shader(gl.FRAGMENT_SHADER,fragment);gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw new Error('Fabric shader link failed');gl.useProgram(program);const vertices=[],uvs=[],indices=[],n=64;for(let y=0;y<=n;y++)for(let x=0;x<=n;x++){vertices.push((x/n-.5)*2.3,0,(y/n-.5)*1.65);uvs.push(x/n,y/n)}for(let y=0;y<n;y++)for(let x=0;x<n;x++){const k=y*(n+1)+x;indices.push(k,k+1,k+n+1,k+1,k+n+2,k+n+1)}for(let edge=0;edge<4;edge++)for(let j=0;j<n;j++){const points=edge===0?[[j/n,0],[(j+1)/n,0]]:edge===1?[[1,j/n],[1,(j+1)/n]]:edge===2?[[(j+1)/n,1],[j/n,1]]:[[0,(j+1)/n],[0,j/n]];const base=vertices.length/3;for(const [a,b]of points){vertices.push((a-.5)*2.3,0,(b-.5)*1.65,(a-.5)*2.3,-.018,(b-.5)*1.65);uvs.push(a,b,a,b)}indices.push(base,base+1,base+2,base+2,base+1,base+3)}const bind=(name,data,size)=>{const b=gl.createBuffer();buffers.push(b);gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(data),gl.STATIC_DRAW);const a=gl.getAttribLocation(program,name);gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,size,gl.FLOAT,false,0,0)};bind('a_position',vertices,3);bind('a_uv',uvs,2);const ib=gl.createBuffer();buffers.push(ib);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,ib);gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,new Uint16Array(indices),gl.STATIC_DRAW);locations.count=indices.length;['layer','spread','turn','focus','aspect','mobile','active'].forEach(k=>locations[k]=gl.getUniformLocation(program,'u_'+k));gl.enable(gl.DEPTH_TEST);gl.clearColor(0,0,0,0);root.dataset.glReady='true'}catch(e){if(program)gl.deleteProgram(program);program=null;root.dataset.glError='true'}}if(!program)enabled=false;
 const draw=()=>{if(!program||disposed)return;const mobile=width<750,spread=.065+smooth(.08,.3,p)*.58,active=manual>=0?manual:p<.3?-1:Math.min(2,Math.floor((p-.3)/.225));gl.viewport(0,0,canvas.width,canvas.height);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(program);gl.uniform1f(locations.spread,spread);gl.uniform1f(locations.turn,p);gl.uniform1f(locations.focus,smooth(.1,.9,p));gl.uniform1f(locations.aspect,width/height);gl.uniform1f(locations.mobile,mobile?1:0);for(let layer=2;layer>=0;layer--){gl.uniform1f(locations.layer,layer);gl.uniform1f(locations.active,active<0||active===layer?1:.23);gl.drawElements(gl.TRIANGLES,locations.count,gl.UNSIGNED_SHORT,0)}};
 const update=()=>{raf=0;if(disposed)return;const r=root.getBoundingClientRect();if(manual<0)p=enabled?clamp(-r.top/Math.max(1,r.height-stage.offsetHeight)):.18;const active=manual>=0?manual:p<.3?-1:Math.min(2,Math.floor((p-.3)/.225));root.style.setProperty('--intro',active<0?1:0);copies.forEach((c,i)=>c.toggleAttribute('data-active',i===active));buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===active)));root.dataset.layer=String(active);if(visible)draw()};
 const schedule=()=>{if(!raf)raf=requestAnimationFrame(update)};const resize=()=>{const r=stage.getBoundingClientRect();width=r.width;height=r.height;const dpr=Math.min(devicePixelRatio||1,1.5);canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);schedule()};const mode=()=>{root.toggleAttribute('data-motion',enabled);toggle.setAttribute('aria-pressed',String(!enabled));toggle.textContent=enabled?toggle.dataset.off:toggle.dataset.on;manual=-1;resize()};toggle.addEventListener('click',()=>{enabled=!enabled;mode();root.scrollIntoView({block:'start',behavior:'instant'})});const shared=e=>{enabled=e.detail.enabled;mode()};document.addEventListener('ev:motion-mode',shared);buttons.forEach((b,i)=>b.addEventListener('click',()=>{manual=i;manualY=scrollY;p=.39+i*.225;schedule()}));const scroll=()=>{if(Math.abs(scrollY-manualY)>2)manual=-1;schedule()};window.addEventListener('scroll',scroll,{passive:true});const preference=()=>{enabled=!mq.matches;mode()};mq.addEventListener('change',preference);const ro=new ResizeObserver(resize);ro.observe(stage);const io=new IntersectionObserver(es=>{visible=es.some(e=>e.isIntersecting);if(visible)schedule()});io.observe(root);const lost=e=>{e.preventDefault();delete root.dataset.glReady;program=null};canvas.addEventListener('webglcontextlost',lost);const cleanup=e=>{if(e.target.contains(root)){disposed=true;cancelAnimationFrame(raf);ro.disconnect();io.disconnect();window.removeEventListener('scroll',scroll);mq.removeEventListener('change',preference);document.removeEventListener('ev:motion-mode',shared);document.removeEventListener('shopify:section:unload',cleanup);if(gl){buffers.forEach(b=>gl.deleteBuffer(b));if(program)gl.deleteProgram(program)}}};document.addEventListener('shopify:section:unload',cleanup);const shop=root.querySelector('a[href="#ev-shop"]');shop?.addEventListener('click',e=>{const target=document.querySelector('.eh-shop');if(target){e.preventDefault();target.scrollIntoView({block:'start',behavior:'instant'});target.querySelector('a')?.focus({preventScroll:true})}});mode();
 };document.querySelectorAll('[data-fabric-study]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-fabric-study]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-material-film"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const stage=root.querySelector('.ev-film__stage'),video=root.querySelector('video'),intro=root.querySelector('.ev-film__intro'),copies=[...root.querySelectorAll('[data-film-copy]')],buttons=[...root.querySelectorAll('[data-film-step]')],toggle=root.querySelector('[data-film-toggle]'),mq=matchMedia('(prefers-reduced-motion: reduce)');let enabled=!mq.matches&&!navigator.connection?.saveData,near=false,visible=false,disposed=false,raf=0,seekRaf=0,p=0,target=0,manual=-1,manualY=0;const clamp=v=>Math.max(0,Math.min(1,v)),smooth=(a,b,v)=>{const x=clamp((v-a)/(b-a));return x*x*(3-2*x)};
 const seek=()=>{seekRaf=0;if(disposed||!video||!enabled||!visible||document.hidden||!Number.isFinite(video.duration)||video.seeking)return;const delta=target-video.currentTime;if(Math.abs(delta)>.025){video.currentTime=Math.max(0,Math.min(video.duration-.045,video.currentTime+delta*.4))}};
 const load=()=>{if(video&&near&&enabled&&!video.src){video.src=video.dataset.filmSrc;video.load()}};
 const update=()=>{raf=0;if(disposed)return;const r=root.getBoundingClientRect();visible=r.top<innerHeight&&r.bottom>0;if(manual<0)p=enabled?clamp(-r.top/Math.max(1,r.height-stage.offsetHeight)):0;const index=manual>=0?manual:p<.13?-1:Math.min(copies.length-1,Math.floor((p-.13)/.25));root.style.setProperty('--progress',p);root.style.setProperty('--portrait',manual<0?smooth(.74,.98,p):0);intro.toggleAttribute('data-active',index<0);copies.forEach((c,i)=>c.toggleAttribute('data-active',i===index));buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));if(video&&Number.isFinite(video.duration)){target=clamp(p/.86)*(video.duration-.05);if(!seekRaf)seekRaf=requestAnimationFrame(seek)}};
 const schedule=()=>{if(!raf)raf=requestAnimationFrame(update)};const mode=()=>{root.toggleAttribute('data-motion',enabled);manual=-1;toggle.textContent=enabled?toggle.dataset.off:toggle.dataset.on;toggle.setAttribute('aria-pressed',String(!enabled));load();schedule()};const shared=e=>{enabled=e.detail.enabled;mode()};const preference=()=>{enabled=!mq.matches&&!navigator.connection?.saveData;mode()};const scroll=()=>{if(Math.abs(scrollY-manualY)>2)manual=-1;schedule()};const visibility=()=>{if(document.hidden)video?.pause();else schedule()};const io=new IntersectionObserver(entries=>{near=entries.some(e=>e.isIntersecting);load();schedule()},{rootMargin:'700px 0px'});io.observe(root);const ro=new ResizeObserver(schedule);ro.observe(stage);video?.addEventListener('loadeddata',()=>{root.dataset.filmReady='true';schedule()});video?.addEventListener('seeked',()=>{if(!seekRaf)seekRaf=requestAnimationFrame(seek)});video?.addEventListener('error',()=>{delete root.dataset.filmReady;root.dataset.filmError='true'});buttons.forEach((b,i)=>b.addEventListener('click',()=>{manual=i;manualY=scrollY;p=.23+i*.27;schedule()}));toggle.addEventListener('click',()=>{enabled=!enabled;mode();document.dispatchEvent(new CustomEvent('ev:motion-mode',{detail:{enabled}}));root.scrollIntoView({block:'start',behavior:'instant'})});document.addEventListener('ev:motion-mode',shared);document.addEventListener('visibilitychange',visibility);window.addEventListener('scroll',scroll,{passive:true});mq.addEventListener('change',preference);const dispose=e=>{if(e.target.contains(root)){disposed=true;cancelAnimationFrame(raf);cancelAnimationFrame(seekRaf);io.disconnect();ro.disconnect();video?.pause();document.removeEventListener('ev:motion-mode',shared);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('scroll',scroll);mq.removeEventListener('change',preference);document.removeEventListener('shopify:section:unload',dispose)}};document.addEventListener('shopify:section:unload',dispose);mode()};document.querySelectorAll('[data-ev-film]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ev-film]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-material-lab"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const chapters=[...root.querySelectorAll('[data-lab-chapter]')],mq=matchMedia('(prefers-reduced-motion: reduce)');let enabled=!mq.matches&&!navigator.connection?.saveData,raf=0;const clamp=x=>Math.min(1,Math.max(0,x)),smooth=(a,b,x)=>{const p=clamp((x-a)/(b-a));return p*p*(3-2*p)};const update=()=>{raf=0;chapters.forEach((el,i)=>{const r=el.getBoundingClientRect(),height=el.querySelector('.ev-lab__stage').offsetHeight,p=enabled?clamp(-r.top/Math.max(1,r.height-height)):0;el.style.setProperty('--p',p);if(!i){el.style.setProperty('--zoom',enabled?2.35-smooth(.04,.52,p)*1.43:1);el.style.setProperty('--spread',enabled?smooth(.46,.85,p):0);el.style.setProperty('--title',enabled?1-smooth(.32,.53,p):1)}else el.style.setProperty('--detail',enabled?smooth(.28,.63,p):1)})};const schedule=()=>{if(!raf)raf=requestAnimationFrame(update)};const mode=()=>{root.toggleAttribute('data-animated',enabled);schedule()};const sync=e=>{enabled=e.detail.enabled;mode()};const preference=()=>{enabled=!mq.matches;mode()};document.addEventListener('ev:motion-mode',sync);mq.addEventListener('change',preference);window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);const io=new IntersectionObserver(es=>root.toggleAttribute('data-visible',es.some(e=>e.isIntersecting)));io.observe(root);root.querySelectorAll('a[href^="#ev-"]').forEach(a=>a.addEventListener('click',e=>{const target=document.querySelector(a.hash==='#ev-shop'?'.eh-shop':'.eh-wardrobe');if(target){e.preventDefault();target.scrollIntoView({block:'start',behavior:'instant'});target.querySelector('a')?.focus({preventScroll:true})}}));const dispose=e=>{if(e.target.contains(root)){cancelAnimationFrame(raf);io.disconnect();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);document.removeEventListener('ev:motion-mode',sync);mq.removeEventListener('change',preference);document.removeEventListener('shopify:section:unload',dispose)}};document.addEventListener('shopify:section:unload',dispose);mode()};document.querySelectorAll('[data-material-lab]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-material-lab]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-material-performance"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';const shirt=root.dataset.materialProof==='shirt',stage=root.querySelector('.ev-proof__stage'),canvas=root.querySelector('canvas'),gl=canvas.getContext('webgl',{alpha:true,antialias:true,powerPreference:'low-power'}),copies=[...root.querySelectorAll('[data-proof-copy]')],buttons=[...root.querySelectorAll('[data-proof-step]')],toggle=root.querySelector('[data-proof-toggle]'),mq=matchMedia('(prefers-reduced-motion: reduce)');let enabled=!mq.matches&&!navigator.connection?.saveData,visible=false,disposed=false,p=0,manual=-1,manualY=0,raf=0,w=0,h=0,program=null,buffers=[],u={},count=0;
 const clamp=x=>Math.max(0,Math.min(1,x)),smooth=(a,b,x)=>{const n=clamp((x-a)/(b-a));return n*n*(3-2*n)};
 const vs=`attribute vec2 a_uv;uniform float u_progress;uniform float u_stretch;uniform float u_crease;uniform float u_shirt;uniform float u_mobile;uniform float u_aspect;varying vec2 v_uv;varying vec3 v_normal;varying vec3 v_position;void main(){float x=(a_uv.x-.5)*3.0;float y=(a_uv.y-.5)*2.25;float kx=mix(3.2,2.3,u_shirt);float ky=mix(1.5,.65,u_shirt);float phase=x*kx+y*ky+u_progress*1.8;float amp=mix(.13,.32,u_shirt);float fine=sin(x*10.+y*6.)*u_crease*.075;float z=sin(phase)*amp+sin(y*3.1-x*.65)*.18+fine;float dx=cos(phase)*kx*amp-cos(y*3.1-x*.65)*.117+cos(x*10.+y*6.)*u_crease*.75;float dy=cos(phase)*ky*amp+cos(y*3.1-x*.65)*.558+cos(x*10.+y*6.)*u_crease*.45;vec3 pos=vec3(x*(1.+u_stretch),y*(1.-u_stretch*.15),z);vec3 n=normalize(vec3(-dx,-dy,1.));float rz=-.25;mat3 rot=mat3(cos(rz),sin(rz),0.,-sin(rz),cos(rz),0.,0.,0.,1.);pos=rot*pos;n=rot*n;pos.x+=z*.4;float perspective=4.5/(4.5-pos.z);float scale=mix(.85,.30,u_mobile);vec2 projected=pos.xy*scale*perspective;projected.x/=u_aspect;projected+=vec2(mix(.48,0.,u_mobile),mix(.16,.47,u_mobile));v_uv=a_uv;v_normal=n;v_position=pos;gl_Position=vec4(projected,-pos.z*.1,1.);}`;
 const fs=`precision highp float;varying vec2 v_uv;varying vec3 v_normal;varying vec3 v_position;uniform float u_shirt;uniform float u_water;uniform float u_air;uniform float u_progress;float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}void main(){vec2 uv=v_uv;float warp=sin(uv.x*750.);float weft=sin(uv.y*660.);float pattern=mix(.94+.035*warp+.025*weft,.977+.014*warp+.009*weft,u_shirt);float grain=mix(.024,.007,u_shirt);vec3 normal=normalize(v_normal+vec3(warp*grain,weft*grain,0.));vec3 light=normalize(vec3(-.45,.8,1.2));float diffuse=.33+.67*max(0.,dot(normal,light));float spec=pow(max(0.,dot(reflect(-light,normal),vec3(0.,0.,1.))),mix(38.,24.,u_shirt));float sheen=pow(1.-abs(normal.z),2.);vec3 base=mix(vec3(.20,.29,.35),vec3(.88,.90,.89),u_shirt);vec3 color=base*pattern*diffuse+vec3(.7,.83,.92)*spec*mix(.12,.13,u_shirt)+sheen*vec3(.22,.26,.22)*u_shirt;for(int i=0;i<8;i++){float fi=float(i);vec2 center=vec2(.16+hash(vec2(fi,2.))*.71,.2+hash(vec2(fi,4.))*.61-u_progress*.09);vec2 d=(uv-center)*vec2(1.,.78);float r=.012+hash(vec2(fi,8.))*.012;float dist=length(d);float inside=1.-smoothstep(r-.002,r,dist);float rim=smoothstep(r*.65,r*.96,dist)*inside;vec2 dn=d/r;float beadLight=pow(max(0.,1.-length(dn-vec2(-.3,.38))),5.);vec3 bead=color*.6+vec3(.76,.9,1.)*(rim*.5+beadLight*.8);color=mix(color,bead,inside*u_water);}for(int i=0;i<8;i++){float fi=float(i);float xx=.12+fi*.108;float flow=fract(uv.y*1.1+u_progress*3.+fi*.17);float line=exp(-pow((uv.x-xx-sin(uv.y*7.+fi)*.016)*175.,2.));float trail=pow(flow,12.)*line*u_air;color=mix(color,vec3(.60,.78,.77),trail*.4);}float edge=smoothstep(.005,0.,min(min(uv.x,1.-uv.x),min(uv.y,1.-uv.y)));color+=edge*.025;gl_FragColor=vec4(color,1.);}`;
 if(gl){try{const compile=(type,src)=>{const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)){gl.deleteShader(s);throw Error('material shader')}return s};program=gl.createProgram();const v=compile(gl.VERTEX_SHADER,vs),f=compile(gl.FRAGMENT_SHADER,fs);gl.attachShader(program,v);gl.attachShader(program,f);gl.linkProgram(program);gl.deleteShader(v);gl.deleteShader(f);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('material link');gl.useProgram(program);const vertices=[],indices=[],nx=96,ny=72;for(let y=0;y<=ny;y++)for(let x=0;x<=nx;x++)vertices.push(x/nx,y/ny);for(let y=0;y<ny;y++)for(let x=0;x<nx;x++){const k=y*(nx+1)+x;indices.push(k,k+1,k+nx+1,k+1,k+nx+2,k+nx+1)}const vb=gl.createBuffer(),ib=gl.createBuffer();buffers.push(vb,ib);gl.bindBuffer(gl.ARRAY_BUFFER,vb);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(vertices),gl.STATIC_DRAW);const loc=gl.getAttribLocation(program,'a_uv');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,ib);gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,new Uint16Array(indices),gl.STATIC_DRAW);count=indices.length;['progress','stretch','crease','shirt','mobile','aspect','water','air'].forEach(k=>u[k]=gl.getUniformLocation(program,'u_'+k));gl.enable(gl.DEPTH_TEST);gl.clearColor(0,0,0,0);root.dataset.glReady='true'}catch(e){if(program)gl.deleteProgram(program);program=null;root.dataset.glError='true'}}if(!program)enabled=false;
 const draw=()=>{if(!program||!visible||disposed||document.hidden)return;const step=manual>=0?manual:p<.17?-1:Math.min(2,Math.floor((p-.17)/.255));const phase=manual>=0?.55:clamp((p-(.17+step*.255))/.255);const stretch=shirt?(step===2?Math.sin(phase*Math.PI)*.075:0):(step===0?Math.sin(phase*Math.PI)*.30:0);const crease=shirt?.10:(step===2?(1-smooth(.12,.8,phase))*.85:.08);gl.viewport(0,0,canvas.width,canvas.height);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(program);gl.uniform1f(u.progress,p);gl.uniform1f(u.stretch,stretch);gl.uniform1f(u.crease,crease);gl.uniform1f(u.shirt,shirt?1:0);gl.uniform1f(u.mobile,w<750?1:0);gl.uniform1f(u.aspect,w/h);gl.uniform1f(u.water,!shirt&&step===1?1:0);gl.uniform1f(u.air,shirt&&step===1?1:0);gl.drawElements(gl.TRIANGLES,count,gl.UNSIGNED_SHORT,0)};
 const update=()=>{raf=0;if(disposed)return;if(manual<0){const r=root.getBoundingClientRect();p=enabled?clamp(-r.top/Math.max(1,r.height-stage.offsetHeight)):0}const step=manual>=0?manual:p<.17?-1:Math.min(2,Math.floor((p-.17)/.255));root.style.setProperty('--progress',p);root.style.setProperty('--intro',step<0?1:0);root.style.setProperty('--portrait',manual<0?smooth(.92,1,p):0);root.querySelector('.ev-proof__intro').style.visibility=step<0?'visible':'hidden';copies.forEach((c,i)=>c.toggleAttribute('data-active',i===step));buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===step)));root.dataset.step=String(step);draw()};const schedule=()=>{if(!raf)raf=requestAnimationFrame(update)};const resize=()=>{const r=stage.getBoundingClientRect();w=r.width;h=r.height;const dpr=Math.min(devicePixelRatio||1,1.5);canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr);schedule()};const mode=()=>{root.toggleAttribute('data-motion',enabled);manual=-1;toggle.textContent=enabled?toggle.dataset.off:toggle.dataset.on;toggle.setAttribute('aria-pressed',String(!enabled));resize()};toggle.addEventListener('click',()=>{enabled=!enabled;mode();root.scrollIntoView({block:'start',behavior:'instant'})});buttons.forEach((b,i)=>b.addEventListener('click',()=>{manual=i;manualY=scrollY;p=.30+i*.255;schedule()}));const scroll=()=>{if(Math.abs(scrollY-manualY)>2)manual=-1;schedule()};const shared=e=>{enabled=e.detail.enabled;mode()};const preference=()=>{enabled=!mq.matches;mode()};const visibility=()=>{if(!document.hidden)schedule()};window.addEventListener('scroll',scroll,{passive:true});document.addEventListener('ev:motion-mode',shared);document.addEventListener('visibilitychange',visibility);mq.addEventListener('change',preference);const ro=new ResizeObserver(resize);ro.observe(stage);const io=new IntersectionObserver(es=>{visible=es.some(e=>e.isIntersecting);if(visible)schedule()});io.observe(root);canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();delete root.dataset.glReady;program=null});const cleanup=e=>{if(e.target.contains(root)){disposed=true;cancelAnimationFrame(raf);ro.disconnect();io.disconnect();window.removeEventListener('scroll',scroll);document.removeEventListener('ev:motion-mode',shared);document.removeEventListener('visibilitychange',visibility);mq.removeEventListener('change',preference);document.removeEventListener('shopify:section:unload',cleanup);if(gl){buffers.forEach(b=>gl.deleteBuffer(b));if(program)gl.deleteProgram(program)}}};document.addEventListener('shopify:section:unload',cleanup);mode();
 };document.querySelectorAll('[data-material-proof]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-material-proof]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-motion-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.motionReady) return;
      root.dataset.motionReady = 'true';
      const scenes = [...root.querySelectorAll('[data-motion-scene]')];
      const chapters = [...root.querySelectorAll('[data-chapter]')];
      const toggle = root.querySelector('[data-motion-toggle]');
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const parts = Object.fromEntries(['.em-form__background','.em-form__people','.em-word','.em-copy--form','.em-air__portal','.em-air__image','.em-air__beam','.em-copy--air','.em-world__window','.em-copy--world'].map(s => [s,root.querySelector(s)]));
      let active = false, visible = true, raf = 0;
      const clamp = v => Math.max(0,Math.min(1,v));
      const smooth = v => {v=clamp(v);return v*v*(3-2*v);};
      const phase = (p,a,b) => smooth((p-a)/(b-a));
      const style = (s,key,v) => {if(parts[s])parts[s].style[key]=v;};
      const film = root.querySelector('[data-motion-film]');
      let filmTarget = 0;
      const seekFilm = () => {if(film && film.readyState>=2 && !film.seeking && Number.isFinite(film.duration) && Math.abs(film.currentTime-filmTarget)>.06)film.currentTime=filmTarget;};
      if(film){film.addEventListener('loadeddata',()=>{film.dataset.ready='true';seekFilm();});film.addEventListener('seeked',seekFilm);}
      const draw = () => {
        raf=0;if(!active || !visible || !root.isConnected)return;
        const header=document.querySelector('#SiteHeader');
        const inset=Math.max(0,Math.min(innerHeight*.25,header ? header.getBoundingClientRect().bottom : 0));
        root.style.setProperty('--em-inset',`${inset}px`);
        const rect=root.getBoundingClientRect(), span=rect.height-innerHeight;
        const p=clamp(-rect.top/Math.max(1,span));
        const a=phase(p,.25,.39), b=phase(p,.63,.76), depth=phase(p,0,.30);
        const opacity=[1-a,a*(1-b),b];
        const current=p<.33?0:p<.70?1:2;
        scenes.forEach((s,i)=>{s.style.opacity=opacity[i];s.toggleAttribute('data-current',i===current);s.inert=i!==current;s.setAttribute('aria-hidden',String(i!==current));});
        style('.em-form__background','transform',`translate3d(${-depth*3}%,${depth*5}%,0) scale(${1+depth*.20})`);
        style('.em-form__background','filter',`brightness(${1-depth*.56})`);
        style('.em-form__people','transform',`translate3d(${-depth*3}%,${depth*5}%,0) scale(${1+depth*.20})`);
        style('.em-word','transform',`translate3d(-50%,${-depth*60}%,0) scale(${1+depth*.45})`);
        style('.em-copy--form','opacity',1-phase(p,.14,.28));
        style('.em-copy--form','transform',`translateY(${-depth*40}px)`);
        const reveal=phase(p,.25,.43), macro=phase(p,.38,.66);
        style('.em-air__portal','clipPath',`inset(${(1-reveal)*28}% ${(1-reveal)*18}% ${(1-reveal)*28}% ${(1-reveal)*18}% round ${(1-reveal)*160}px)`);
        style('.em-air__portal','transform',`perspective(1200px) rotateY(${(1-reveal)*-22}deg)`);
        style('.em-air__image','transform',`scale(${1+macro*.32}) translateY(${macro*3}%)`);
        style('.em-air__beam','transform',`translateX(${-40+macro*70}%)`);
        style('.em-copy--air','opacity',phase(p,.32,.43)*(1-phase(p,.62,.73)));
        style('.em-copy--air','transform',`translateY(${(1-reveal)*45}px)`);
        const world=phase(p,.64,.88);
        style('.em-world__window','transform',`perspective(1500px) rotateX(${(1-world)*9}deg) scale(${.62+world*.38})`);
        style('.em-world__window','borderRadius',`${(1-world)*65}px`);
        style('.em-copy--world','opacity',phase(p,.73,.87));
        style('.em-copy--world','transform',`translateY(${(1-world)*45}px)`);
        chapters.forEach((c,i)=>{c.style.setProperty('--chapter-fill',clamp(p*3-i));if(i===current)c.setAttribute('aria-current','step');else c.removeAttribute('aria-current');});
        if(film && p>.52 && !navigator.connection?.saveData){if(!film.src){film.src=film.dataset.src;film.load();}if(Number.isFinite(film.duration)){filmTarget=clamp((p-.70)/.30)*Math.max(0,film.duration-.08);seekFilm();}}
      };
      const tick=()=>{if(!raf && active && visible)raf=requestAnimationFrame(draw);};
      const setMode=(on)=>{
        active=on;root.toggleAttribute('data-enhanced',on);root.toggleAttribute('data-static',!on);
        toggle.setAttribute('aria-pressed',String(!on));toggle.textContent=on?toggle.dataset.disableLabel:toggle.dataset.enableLabel;
        if(!on){scenes.forEach(s=>{s.removeAttribute('style');s.removeAttribute('aria-hidden');s.inert=false;});Object.values(parts).forEach(e=>e?.removeAttribute('style'));if(film){film.removeAttribute('data-ready');film.pause();}}
        tick();
      };
      toggle.addEventListener('click',()=>{const top=root.getBoundingClientRect().top+scrollY;setMode(!active);window.scrollTo({top:Math.max(0,top),behavior:'instant'});});
      const change=()=>setMode(!media.matches);media.addEventListener('change',change);
      chapters.forEach((c,i)=>c.addEventListener('click',()=>{const start=root.getBoundingClientRect().top+scrollY;const stops=[0,.49,.93];window.scrollTo({top:start+stops[i]*(root.offsetHeight-innerHeight),behavior:'instant'});}));
      root.querySelector('[data-motion-shop]').addEventListener('click',e=>{const dest=document.querySelector('[data-evergreen-hub] .eh-shop');if(dest){e.preventDefault();dest.scrollIntoView({behavior:'instant',block:'start'});dest.querySelector('a')?.focus({preventScroll:true});}});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;tick();},{rootMargin:'200px'});observer.observe(root);
      window.addEventListener('scroll',tick,{passive:true});window.addEventListener('resize',tick,{passive:true});
      const cleanup=e=>{if(e.target.contains(root)){observer.disconnect();cancelAnimationFrame(raf);window.removeEventListener('scroll',tick);window.removeEventListener('resize',tick);media.removeEventListener('change',change);document.removeEventListener('shopify:section:unload',cleanup);}};
      document.addEventListener('shopify:section:unload',cleanup);
      setMode(!media.matches);
    };
    document.querySelectorAll('[data-motion-story]').forEach(init);
    document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-motion-story]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-product-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const connection = navigator.connection;
  const clamp = n => Math.max(0, Math.min(1, n));
  let raf = 0;
  const schedule = () => { if (!raf) raf = requestAnimationFrame(tick); };
  const tick = () => { raf = 0; instances.forEach(instance => instance.update()); };
  class ProductMotion {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('video');
      this.steps = [...root.querySelectorAll('[data-motion-step]')];
      this.button = root.querySelector('[data-motion-play]');
      this.count = root.querySelector('.pm__count');
      this.hint = root.querySelector('.pm__hint');
      this.events = new AbortController();
      const on = (node, type, handler) => node.addEventListener(type, handler, {signal:this.events.signal});
      this.loaded = false; this.near = false; this.visible = false; this.manual = false; this.failed = false; this.progress = 0; this.requested = 0;
      this.button.hidden = !(this.video.dataset.desktopSrc || this.video.dataset.mobileSrc);
      on(this.button, 'click', () => this.togglePlay());
      on(this.video, 'loadedmetadata', () => { this.seek(); schedule(); });
      on(this.video, 'loadeddata', () => { root.classList.add('is-ready'); schedule(); });
      on(this.video, 'seeked', () => { root.classList.add('is-ready'); this.seek(); });
      on(this.video, 'play', () => this.setPlaying(true));
      on(this.video, 'pause', () => this.setPlaying(false));
      on(this.video, 'ended', () => this.setPlaying(false));
      on(this.video, 'error', () => { this.failed = true; this.manual = false; root.classList.remove('is-ready'); this.mode(); });
      on(this.video, 'timeupdate', () => {
        if (this.manual && Number.isFinite(this.video.duration)) this.paint(this.video.currentTime / this.video.duration);
      });
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near && !this.staticMode) {
          const poster = root.querySelector('.pm__poster');
          if (poster) poster.loading = 'eager';
          this.load();
        }
        schedule();
      }, {rootMargin:'70% 0px'});
      this.observer.observe(root);
      this.mode();
      root.dataset.motionReady = 'true';
    }
    mode() {
      this.staticMode = reduced.matches || Boolean(connection && connection.saveData) || this.failed;
      this.root.classList.toggle('is-enhanced', !this.staticMode);
      this.root.dataset.motionMode = this.staticMode ? 'manual' : 'scroll';
      this.steps.forEach(step => step.removeAttribute('aria-hidden'));
      if (this.staticMode) { this.video.pause(); this.manual = false; }
      else if (this.near) this.load();
      schedule();
    }
    load() {
      if (this.loaded || this.failed) return;
      const source = (mobile.matches && this.video.dataset.mobileSrc) || this.video.dataset.desktopSrc;
      if (!source) return;
      this.loaded = true;
      this.video.muted = true;
      this.video.src = source;
      this.video.preload = 'auto';
      this.video.load();
    }
    paint(value) {
      const progress = clamp(value);
      const active = Math.min(this.steps.length - 1, Math.floor(progress * this.steps.length));
      this.root.style.setProperty('--pm-progress', progress.toFixed(4));
      this.root.dataset.motionProgress = progress.toFixed(3);
      this.steps.forEach((step, index) => {
        step.classList.toggle('is-current', index === active);
        if (!this.staticMode) step.setAttribute('aria-hidden', String(index !== active));
      });
      this.count.textContent = String(active + 1).padStart(2,'0') + ' / ' + String(this.steps.length).padStart(2,'0');
    }
    seek() {
      const v = this.video;
      if (this.manual || this.staticMode || this.failed || document.hidden || v.readyState < 1 || !Number.isFinite(v.duration) || v.seeking) return;
      const target = this.requested * Math.max(0, v.duration - 0.055);
      if (Math.abs(v.currentTime - target) > 0.055) {
        try { v.currentTime = target; } catch (_) { /* A poster remains visible until the media is seekable. */ }
      }
    }
    update() {
      const rect = this.root.getBoundingClientRect();
      const height = this.root.querySelector('.pm__stage').getBoundingClientRect().height;
      this.visible = rect.top < innerHeight && rect.bottom > 0;
      if (!this.visible || document.hidden) {
        if (!this.video.paused) this.video.pause();
        this.manual = false;
        return;
      }
      if (this.staticMode) return;
      this.load();
      this.progress = clamp(-rect.top / Math.max(1, rect.height - height));
      this.requested = this.progress;
      if (!this.manual) { this.paint(this.progress); this.seek(); }
    }
    setPlaying(playing) {
      this.button.setAttribute('aria-pressed', String(playing));
      const text = playing ? '暫停影片' : '播放影片';
      this.button.querySelector('span').textContent = text;
      this.button.setAttribute('aria-label', this.root.querySelector('h2').textContent + '：' + text);
      this.hint.textContent = playing ? '影片播放中' : '捲動探索細節';
    }
    async togglePlay() {
      if (this.manual && !this.video.paused) {
        this.video.pause(); return;
      }
      this.load();
      this.manual = true;
      if (Number.isFinite(this.video.duration) && this.video.currentTime > this.video.duration - 0.15) this.video.currentTime = 0;
      try { await this.video.play(); }
      catch (_) { this.manual = false; this.setPlaying(false); }
    }
    destroy() { this.events.abort(); this.observer.disconnect(); this.video.pause(); }
  }
  const init = scope => {
    scope.querySelectorAll('[data-product-motion]').forEach(root => {
      if (!instances.has(root)) instances.set(root, new ProductMotion(root));
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  window.addEventListener('scroll', () => {
    instances.forEach(instance => {
      if (instance.manual && !instance.staticMode) { instance.video.pause(); instance.manual = false; }
    });
    schedule();
  }, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      instances.forEach(instance => { instance.video.pause(); instance.manual = false; });
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    } else schedule();
  });
  reduced.addEventListener('change', () => instances.forEach(instance => instance.mode()));
  if (connection) connection.addEventListener('change', () => instances.forEach(instance => instance.mode()));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-shop-edit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.filterReady) return;
    root.dataset.filterReady = 'true';
    const items = [...root.querySelectorAll('[data-shop-item]')];
    const editorials = [...root.querySelectorAll('[data-shop-editorial]')];
    const grid = root.querySelector('.ev-shop__products');
    const originalOrder = [...grid.children];
    const genderButtons = [...root.querySelectorAll('[data-gender]')];
    const categoryButtons = [...root.querySelectorAll('[data-category]')];
    const status = root.querySelector('[data-shop-status]');
    const batchSize = 8;
    let limit = batchSize;
    const more = root.querySelector('[data-shop-more]');
    let gender = 'all', category = 'all';
    const matchesGender = item => gender === 'all' || item.dataset.audience === gender || item.dataset.audience === 'unisex';
    const update = () => {
      const matching = items.filter(item => matchesGender(item) && (category === 'all' || item.dataset.kind === category));
      const visible = matching.slice(0, limit);
      items.forEach(item => { item.hidden = !visible.includes(item); });
      const filtered = gender !== 'all' || category !== 'all';
      root.classList.toggle('is-filtered', filtered);
      const eligible = editorials.filter(tile => matchesGender(tile) && (category === 'all' || tile.dataset.kind === category));
      editorials.forEach(tile => {
        const slot = eligible.indexOf(tile);
        const afterCount = (slot + 1) * 4;
        tile.hidden = slot < 0 || visible.length < afterCount;
        // Move only editorial nodes; native product cards and their listeners stay stable.
        const nextProduct = matching[afterCount];
        grid.insertBefore(tile, nextProduct || null);
      });
      genderButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gender === gender)));
      categoryButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      status.textContent = visible.length + ' / ' + matching.length + ' ' + status.dataset.label;
      more.parentElement.hidden = visible.length >= matching.length;
      root.querySelector('.ev-shop__empty').hidden = visible.length > 0;
      root.dispatchEvent(new CustomEvent('ev:filter'));
    };
    genderButtons.forEach(button => button.addEventListener('click', () => { gender = button.dataset.gender; limit = batchSize; update(); }));
    categoryButtons.forEach(button => button.addEventListener('click', () => { category = button.dataset.category; limit = batchSize; update(); }));
    root.querySelector('[data-shop-reset]').addEventListener('click', () => {
      gender = 'all'; category = 'all'; limit = batchSize; update(); genderButtons[0].focus();
    });
    more.addEventListener('click', () => {
      const firstNew = items.filter(item => matchesGender(item) && (category === 'all' || item.dataset.kind === category))[limit];
      limit += batchSize; update();
      const link = firstNew?.querySelector('[data-family-panel]:not([hidden]) .grid-product__link, .grid-product__link');
      link?.focus({preventScroll: true});
    });
    root.querySelector('.ev-shop__filters').hidden = false;
    update();
  };
  document.querySelectorAll('[data-editorial-shop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-editorial-shop]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evergreen-tech-formal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (root) => {
      if (root.dataset.ehReady) return;
      root.dataset.ehReady = 'true';
      root.querySelectorAll('[data-detail-button]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-detail-button]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          root.querySelectorAll('[data-detail-panel]').forEach((panel) => { panel.hidden = panel.dataset.detailPanel !== button.dataset.detailButton; });
        });
      });
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let ticking = false;
      const hero = root.querySelector('.eh-hero');
      const detail = root.querySelector('.eh-stage');
      const warmImages = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          detail.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
          warmImages.disconnect();
        }
      }, { rootMargin: '300px' });
      if (detail) warmImages.observe(detail);
      const draw = () => {
        ticking = false;
        if (!root.isConnected || !visible || motion.matches || innerWidth < 990) return;
        const h = hero ? hero.getBoundingClientRect() : {top:0,height:1};
        const d = detail ? detail.getBoundingClientRect() : {top:0,height:1};
        root.style.setProperty('--eh-progress', Math.max(0, Math.min(1, -h.top / h.height)));
        root.style.setProperty('--eh-detail-progress', Math.max(0, Math.min(1, (innerHeight - d.top) / (innerHeight + d.height))));
      };
      const tick = () => { if (!ticking && visible) { ticking = true; requestAnimationFrame(draw); } };
      const observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; tick(); });
      observer.observe(root);
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      root.addEventListener('shopify:section:unload', () => { observer.disconnect(); window.removeEventListener('scroll', tick); window.removeEventListener('resize', tick); });
      draw();
    };
    document.querySelectorAll('[data-evergreen-hub]').forEach(start);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-evergreen-hub]').forEach(start));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g52-alpine-cinema"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-duo-hero]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='1';
 const reduce=matchMedia('(prefers-reduced-motion: reduce)'),stage=root.firstElementChild,videos=[...root.querySelectorAll('video')],buttons=[...root.querySelectorAll('[data-phase]')],canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d');
 const clamp=n=>Math.max(0,Math.min(1,n)),smooth=n=>{n=clamp(n);return n*n*(3-2*n)};
 let queued=0,visible=false,w=0,h=0,progress=0;
 const seek=v=>{if(reduce.matches)return;if(v.readyState>=1&&!v.seeking&&Number.isFinite(v.duration)){const t=(v._progress||0)*Math.max(0,v.duration-.065);if(Math.abs(v.currentTime-t)>.025)v.currentTime=t}};
 const load=v=>{if(!reduce.matches&&!v.getAttribute('src')){v.src=v.dataset.src;v.load()}};
 videos.forEach(v=>{v.addEventListener('loadedmetadata',()=>seek(v));v.addEventListener('seeked',()=>seek(v));v.addEventListener('play',()=>v.pause())});
 const paint=()=>{queued=0;const range=Math.max(1,root.offsetHeight-stage.offsetHeight);progress=reduce.matches?0:clamp(-root.getBoundingClientRect().top/range);const left=clamp(progress/.45),right=clamp((progress-.55)/.45),handoff=smooth((progress-.45)/.1);root.dataset.phase=progress<.5?'shell':'puffer';
 root.style.setProperty('--left',left.toFixed(4));root.style.setProperty('--right',right.toFixed(4));root.style.setProperty('--handoff',handoff.toFixed(4));root.style.setProperty('--warmth',smooth((right-.5)/.45).toFixed(4));root.style.setProperty('--p',progress.toFixed(4));
 buttons.forEach((b,i)=>{if((progress<.5?0:1)===i)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current')});
 videos[0]._progress=left;videos[1]._progress=right;if(visible&&!reduce.matches){videos.forEach(load);videos.forEach(seek)}
 const box=canvas.getBoundingClientRect();if(w!==Math.round(box.width)||h!==Math.round(box.height)){w=Math.round(box.width);h=Math.round(box.height);canvas.width=w;canvas.height=h}ctx.clearRect(0,0,w,h);
 if(!reduce.matches&&visible){for(let i=0;i<45;i++){const depth=1+i%3,phase=left*430*depth,x=((i*101.17+phase*.75)%(w+50))-25,y=((i*67.37+phase)%(h+50))-25;ctx.strokeStyle=`rgba(255,255,255,${.16+depth*.12})`;ctx.lineWidth=depth*.65;ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(x+depth*2,y+depth*3);ctx.stroke();ctx.fillStyle=ctx.strokeStyle;ctx.beginPath();ctx.ellipse(x,y,depth*.75,depth*.9,0,0,Math.PI*2);ctx.fill()}}
 };
 const request=()=>{if(!queued)queued=requestAnimationFrame(paint)};
 buttons.forEach(b=>b.addEventListener('click',()=>{const p=b.dataset.phase==='0'?.08:.61;scrollTo({top:scrollY+root.getBoundingClientRect().top+p*Math.max(1,root.offsetHeight-stage.offsetHeight),behavior:'instant'})}));
 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;request()},{rootMargin:'300px'});observer.observe(root);addEventListener('scroll',request,{passive:true});addEventListener('resize',request);reduce.addEventListener('change',()=>{if(reduce.matches)videos.forEach(v=>{v.pause();v.removeAttribute('src');v.load()});request()});paint();
 });init();document.addEventListener('shopify:section:load',init)})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g52-alpine-journey"] && !Shopify.designMode) return;
  try {
    
(() => {const host=document.querySelector('#G52Journey');if(!host)return;const initJourney=()=>{
const disclosure=host.querySelector('.g52-journey-disclosure');
const root=document.querySelector('#g52-long-journey'),scenes=[...document.querySelectorAll('#G52Journey .scene')];
const cloud=document.querySelector('#G52Journey .cloud'),white=document.querySelector('#G52Journey .whiteout'),fabric=document.querySelector('#G52Journey .fabric-wipe'),iris=document.querySelector('#G52Journey .iris'),canvas=document.querySelector('#G52Journey #g52-long-snow'),ctx=canvas.getContext('2d');
const clamp=(n,a=0,b=1)=>Math.max(a,Math.min(b,n)),smooth=n=>{n=clamp(n);return n*n*(3-2*n)},mix=(a,b,t)=>a+(b-a)*t;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
let total=0,target=0,p=0,raf=0,last=0,w=innerWidth,h=innerHeight;
scenes.forEach((s,i)=>{s.setAttribute('aria-hidden',String(i>0));s._start=total;s._span=Number(s.dataset.span)||1;total+=s._span});

function loadVideo(v){if(reduced)return;const src=v.dataset.mobile?(mobileMedia.matches?v.dataset.mobile:v.dataset.desktop):v.dataset.src;if(src&&v.getAttribute('src')!==src){v.src=src;v.load()}}
function seek(v){if(v.readyState>=1&&!v.seeking&&Number.isFinite(v.duration)){const t=clamp(v._target||0,0,Math.max(0,v.duration-.045));if(Math.abs(v.currentTime-t)>.024)v.currentTime=t}}
scenes.forEach(s=>{const v=s.querySelector('video');if(v){v.addEventListener('loadedmetadata',()=>{measure();seek(v)});v.addEventListener('seeked',()=>seek(v))}});
function measure(){if(!disclosure.open)return;target=clamp(-root.getBoundingClientRect().top/Math.max(1,root.offsetHeight-innerHeight));if(!raf&&!reduced&&root.getBoundingClientRect().top<innerHeight*1.5&&root.getBoundingClientRect().bottom>0)raf=requestAnimationFrame(draw)}
function resize(){w=innerWidth;h=innerHeight;canvas.width=w;canvas.height=h;measure()}
function draw(now){raf=0;const dt=last?Math.min(60,now-last):16;last=now;p=mix(p,target,1-Math.exp(-dt/65));if(Math.abs(p-target)<.000025)p=target;const u=p*total;
 scenes.forEach((s,i)=>{const local=u-s._start,q=clamp(local/s._span),photo=s.querySelector('.photo'),active=local>=-.15&&local<=s._span+.15;
  const enter=i===0?1:smooth((local+.12)/.24),exit=i===scenes.length-1?1:1-smooth((local-s._span+.12)/.24);
  s.style.opacity=active?enter*exit:0;s.style.visibility=active?'visible':'hidden';s.setAttribute('aria-hidden',String(local<0||local>=s._span));
  if(photo.tagName==='VIDEO'&&active){loadVideo(photo);const next=scenes[i+1]?.querySelector('video');if(next&&q>.6)loadVideo(next);photo._target=q*Math.max(0,(photo.duration||0)-.045);seek(photo)}
  let z=1,y=0;if(s.classList.contains('intro')){z=mix(1,1.11,smooth(q));y=mix(0,-2,smooth(q))}if(s.classList.contains('ride'))z=mix(1.06,1,q);
  photo.style.transform=`translate3d(0,${y}%,0) scale(${z})`;
  s.querySelectorAll('.copy').forEach(c=>{const a=Number(c.dataset.start)||0,b=Number(c.dataset.end)||1,t=(q-a)/(b-a),first=i===0&&a===0,final=i===scenes.length-1&&b===1;
   const alpha=(first?1:smooth(t/.16))*(final?1:1-smooth((t-.80)/.20));c.style.opacity=alpha;c.style.visibility=t<-.05||t>1.05?'hidden':'visible';c.setAttribute('aria-hidden',String(t<0||t>=1));const side=c.classList.contains('right')?1:-1;c.style.transform=`translate3d(${side*(1-alpha)*16}px,${(1-alpha)*12}px,0)`;c.querySelector('.detail').style.opacity=smooth((t-.16)/.20)*.85;
  });
 });
 let snow=0,pan=0,dark=0,detail=0,panPhase=0;scenes.slice(1).forEach(s=>{const pulse=clamp(1-Math.abs(u-s._start)/.18);if(s.dataset.transition==='snow')snow=Math.max(snow,pulse);if(s.dataset.transition==='fabric'&&pulse>pan){pan=pulse;panPhase=u-s._start}if(s.dataset.transition==='iris')dark=Math.max(dark,pulse);if(s.dataset.transition==='detail')detail=Math.max(detail,pulse)});
 white.style.opacity=smooth(snow);cloud.style.opacity=snow*.6;cloud.style.transform=`translate3d(${Math.sin(u*4)*20}%,0,0)`;fabric.style.opacity=Math.max(smooth(pan),detail*.8);fabric.style.transform=`translateX(${Math.sin(panPhase*8)*40}%) rotate(-12deg)`;iris.style.opacity=smooth(dark);
 canvas.style.opacity=snow;ctx.clearRect(0,0,w,h);if(snow>0){for(let j=0;j<70;j++){const d=1+j%3,xx=((j*137.73+u*170*d)%(w+100))-50,yy=((j*93.17+u*400*d)%(h+100))-50;ctx.fillStyle=`rgba(255,255,255,${.25+d*.16})`;ctx.beginPath();ctx.ellipse(xx,yy,d*.8,d*2.5,-.5,0,Math.PI*2);ctx.fill()}}
 if(p!==target)raf=requestAnimationFrame(draw);else last=0;
}

const mobileMedia=matchMedia('(max-width:700px)');
function selectMedia(){scenes.forEach(s=>{const v=s.querySelector('video');if(v.dataset.mobile){v.poster=mobileMedia.matches?v.dataset.posterMobile:v.dataset.posterDesktop;if(v.getAttribute('src'))loadVideo(v)}})}
mobileMedia.addEventListener('change',selectMedia);selectMedia();
if(reduced){document.querySelector('#G52Journey').classList.add('reduced');scenes.forEach(s=>{s.setAttribute('aria-hidden','false');s.querySelectorAll('.copy').forEach(c=>c.setAttribute('aria-hidden','false'));const v=s.querySelector('video');if(v){v.controls=true;const start=()=>{if(!v.getAttribute('src')){v.src=v.dataset.mobile?(mobileMedia.matches?v.dataset.mobile:v.dataset.desktop):v.dataset.src;v.load();v.play().catch(()=>{})}};v.addEventListener('pointerdown',start);v.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter')start()})}})}else{addEventListener('scroll',measure,{passive:true});addEventListener('resize',resize);resize()}

if(typeof root!=='undefined' && typeof scenes!=='undefined'){

document.querySelector('#G52Journey').classList.remove('no-js');
const chapterNav=document.querySelector('#G52Journey .long-chapter-nav');
const chapterButtons=[...chapterNav.querySelectorAll('[data-chapter]')];
const chapterScenes=chapterButtons.map(b=>document.getElementById(`long-chapter-${b.dataset.chapter}`));
let navFrame=0;
function updateChapterNav(){
 navFrame=0;
 const bounds=root.getBoundingClientRect();
 chapterNav.hidden=!disclosure.open||reduced||bounds.top>innerHeight*.65||bounds.bottom<=innerHeight*.45;
 const unit=clamp(-bounds.top/Math.max(1,root.offsetHeight-innerHeight))*total;
 const lightScene=scenes.find(s=>unit>=s._start&&unit<s._start+s._span);chapterNav.dataset.light=String(lightScene&&['float','zip','heat','layer'].some(name=>lightScene.classList.contains(name)));
 let active=0;chapterScenes.forEach((s,i)=>{if(unit>=s._start)active=i});
 chapterButtons.forEach((b,i)=>{if(i===active)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current')});
}
chapterButtons.forEach((b,i)=>b.addEventListener('click',()=>{
 const scene=chapterScenes[i];

 const destination=scrollY+root.getBoundingClientRect().top+(scene._start+scene._span*.22)/total*(root.offsetHeight-innerHeight);
 scrollTo({top:destination,behavior:'instant'});
}));
addEventListener('scroll',()=>{if(!navFrame)navFrame=requestAnimationFrame(updateChapterNav)},{passive:true});
addEventListener('resize',updateChapterNav);
document.querySelectorAll('#G52Journey a[href="#g49-shop"]').forEach(a=>a.addEventListener('click',()=>{

 document.getElementById('g49-shop').focus({preventScroll:true});
}));
disclosure.addEventListener('toggle',()=>{
 if(!disclosure.open){cancelAnimationFrame(raf);raf=0;last=0;scenes.forEach(s=>s.querySelectorAll('video').forEach(v=>v.pause()))}
 else resize();
 updateChapterNav();
});
chapterNav.querySelector('[data-journey-stories]').addEventListener('click',e=>{
 const stories=document.getElementById('G52Stories');if(!stories)return;
 e.preventDefault();stories.scrollIntoView({behavior:'instant',block:'start'});
 stories.setAttribute('tabindex','-1');stories.focus({preventScroll:true});
 history.replaceState(null,'','#G52Stories');updateChapterNav();
});
updateChapterNav();

}

};initJourney();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g52-alpine-navigation"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-g52-section-nav]').forEach(nav=>{if(nav.dataset.ready)return;nav.dataset.ready='1';const links=[...nav.querySelectorAll('a')],targets=links.map(a=>document.querySelector(a.getAttribute('href')));let queued=false;const paint=()=>{queued=false;let current=-1;targets.forEach((t,i)=>{if(t&&t.getBoundingClientRect().top<innerHeight*.4)current=i});links.forEach((a,i)=>{if(i===current)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')})};addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(paint)}},{passive:true});paint()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-alpine-launch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const autoplayDuration = 4000;
    const focusAutoplayDuration = 7000;

    const initializeFocusCarousels = (scope) => {
      scope.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.dataset.tzdFocusReady === 'true') return;
        const slides = Array.from(root.querySelectorAll('[data-tzd-focus-slide]'));
        const metaSlides = Array.from(root.querySelectorAll('[data-tzd-focus-meta]'));
        const controls = Array.from(root.querySelectorAll('[data-tzd-focus-control]'));
        const media = root.querySelector('.tzd-brand-hub__focus-editorial-media');
        if (slides.length === 0 || slides.length !== controls.length || !media) return;

        root.dataset.tzdFocusReady = 'true';
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        let reduceMotion = motionPreference.matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let activeIndex = 0;
        let timer = 0;
        let isNear = !('IntersectionObserver' in window);
        let isVisible = isNear;
        let nearObserver;
        let visibleObserver;

        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.controls = reduceMotion;
        });

        const loadVideo = (video) => {
          if (!video || video.preload !== 'none') return;
          video.preload = 'metadata';
          video.load();
        };

        const canAutoplay = () => isVisible && !reduceMotion && !document.hidden;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const pauseVideos = () => {
          clearAutoplay();
          root.dataset.tzdFocusPlaying = 'false';
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
        };

        const activate = (requestedIndex) => {
          const previousIndex = activeIndex;
          activeIndex = (requestedIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const selected = index === activeIndex;
            const video = slide.querySelector('video');
            slide.classList.toggle('is-active', selected);
            slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
            slide.setAttribute('tabindex', selected ? '0' : '-1');
            if (!video) return;
            video.controls = reduceMotion;
            if (selected && (isNear || isVisible) && !document.hidden) loadVideo(video);
            if (selected && canAutoplay()) {
              if (previousIndex !== activeIndex) {
                try { video.currentTime = 0; } catch (error) {}
              }
              const playback = video.play();
              if (playback && typeof playback.then === 'function') {
                playback.then(() => {
                  if (signal.aborted || !canAutoplay() || index !== activeIndex) video.pause();
                }).catch(() => {
                  if (!signal.aborted && canAutoplay() && index === activeIndex) video.controls = true;
                });
              }
            } else {
              video.pause();
            }
          });

          metaSlides.forEach((meta, index) => {
            const selected = index === activeIndex;
            meta.classList.toggle('is-active', selected);
            meta.hidden = !selected;
          });

          controls.forEach((control, index) => {
            const selected = index === activeIndex;
            control.classList.toggle('is-active', selected);
            control.setAttribute('aria-pressed', selected ? 'true' : 'false');
            if (!selected) return;
            const progress = control.querySelector('span');
            if (!progress) return;
            progress.style.animation = 'none';
            void progress.offsetWidth;
            progress.style.animation = '';
          });
        };

        const scheduleAutoplay = () => {
          clearAutoplay();
          const playing = canAutoplay() && slides.length > 1;
          root.dataset.tzdFocusPlaying = playing ? 'true' : 'false';
          if (!playing) return;
          timer = window.setTimeout(() => {
            activate(activeIndex + 1);
            scheduleAutoplay();
          }, focusAutoplayDuration);
        };

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            activate(Number(control.dataset.index));
            scheduleAutoplay();
          }, { signal });
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pauseVideos();
            return;
          }
          activate(activeIndex);
          scheduleAutoplay();
        }, { signal });

        motionPreference.addEventListener('change', () => {
          reduceMotion = motionPreference.matches;
          activate(activeIndex);
          scheduleAutoplay();
        }, { signal });

        if ('IntersectionObserver' in window) {
          nearObserver = new IntersectionObserver((entries) => {
            isNear = entries.some((entry) => entry.isIntersecting);
            if (isNear && !document.hidden) loadVideo(slides[activeIndex].querySelector('video'));
          }, { rootMargin: '200px 0px' });
          visibleObserver = new IntersectionObserver((entries) => {
            isVisible = entries.some((entry) => entry.isIntersecting);
            if (!isVisible) {
              pauseVideos();
              return;
            }
            activate(activeIndex);
            scheduleAutoplay();
          });
          nearObserver.observe(media);
          visibleObserver.observe(media);
        }

        activate(0);
        scheduleAutoplay();

        root.tzdFocusCleanup = () => {
          pauseVideos();
          if (nearObserver) nearObserver.disconnect();
          if (visibleObserver) visibleObserver.disconnect();
          controller.abort();
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
          root.removeAttribute('data-tzd-focus-ready');
          root.removeAttribute('data-tzd-focus-playing');
          delete root.tzdFocusCleanup;
        };
      });
    };

    const initialize = (scope) => {
      initializeFocusCarousels(scope);
      scope.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.dataset.tzdTabsReady === 'true') return;
        const tabs = Array.from(root.querySelectorAll('[data-tzd-system-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-tzd-system-panel]'));
        const tablist = root.querySelector('[role="tablist"]');
        if (tabs.length === 0 || !tablist) return;

        root.dataset.tzdTabsReady = 'true';
        root.classList.add('is-tabs-enhanced');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let timer = 0;
        let isUserPaused = false;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const centerTab = (tab, behavior) => {
          const maxScroll = Math.max(0, tablist.scrollWidth - tablist.clientWidth);
          if (maxScroll === 0) return;
          const listRect = tablist.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          const target = tablist.scrollLeft + tabRect.left - listRect.left - (tablist.clientWidth - tabRect.width) / 2;
          tablist.scrollTo({
            left: Math.max(0, Math.min(maxScroll, target)),
            behavior
          });
        };

        const autoplayIsPaused = () => (
          reduceMotion
          || tabs.length < 2
          || isUserPaused
          || document.hidden
        );

        let scheduleAutoplay;

        const activate = (tab, moveFocus, restartAutoplay) => {
          const panelId = tab.getAttribute('aria-controls');
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.setAttribute('tabindex', selected ? '0' : '-1');
          });
          panels.forEach((panel) => {
            const selected = panel.id === panelId;
            panel.classList.toggle('is-active', selected);
            panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
            const link = panel.querySelector('a');
            if (link) link.setAttribute('tabindex', selected ? '0' : '-1');
          });
          centerTab(tab, reduceMotion ? 'auto' : 'smooth');
          if (moveFocus) tab.focus({ preventScroll: true });
          if (restartAutoplay) scheduleAutoplay();
        };

        scheduleAutoplay = () => {
          clearAutoplay();
          tabs.forEach((tab) => tab.classList.remove('is-progressing'));
          const paused = autoplayIsPaused();
          root.classList.toggle('is-autoplay-paused', paused);
          if (paused) return;

          const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
          void activeTab.offsetWidth;
          activeTab.classList.add('is-progressing');
          timer = window.setTimeout(() => {
            const currentIndex = tabs.indexOf(activeTab);
            const nextTab = tabs[(currentIndex + 1) % tabs.length];
            activate(nextTab, false, false);
            scheduleAutoplay();
          }, autoplayDuration);
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            isUserPaused = true;
            activate(tab, false, true);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === index) return;
            event.preventDefault();
            isUserPaused = true;
            activate(tabs[nextIndex], true, true);
          }, { signal });
        });

        document.addEventListener('visibilitychange', scheduleAutoplay, { signal });
        scheduleAutoplay();

        root.tzdTabsCleanup = () => {
          clearAutoplay();
          controller.abort();
          root.classList.remove('is-tabs-enhanced', 'is-autoplay-paused');
          root.removeAttribute('data-tzd-tabs-ready');
          delete root.tzdTabsCleanup;
        };
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.tzdFocusCleanup) root.tzdFocusCleanup();
      });
      event.target.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.tzdTabsCleanup) root.tzdTabsCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-seasonal-brand-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const autoplayDuration = 4000;
    const focusAutoplayDuration = 7000;

    const initializeFocusCarousels = (scope) => {
      scope.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.dataset.tzdFocusReady === 'true') return;
        const slides = Array.from(root.querySelectorAll('[data-tzd-focus-slide]'));
        const metaSlides = Array.from(root.querySelectorAll('[data-tzd-focus-meta]'));
        const controls = Array.from(root.querySelectorAll('[data-tzd-focus-control]'));
        const media = root.querySelector('.tzd-brand-hub__focus-editorial-media');
        if (slides.length === 0 || slides.length !== controls.length || !media) return;

        root.dataset.tzdFocusReady = 'true';
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        let reduceMotion = motionPreference.matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let activeIndex = 0;
        let timer = 0;
        let isNear = !('IntersectionObserver' in window);
        let isVisible = isNear;
        let nearObserver;
        let visibleObserver;

        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.controls = reduceMotion;
        });

        const loadVideo = (video) => {
          if (!video || video.preload !== 'none') return;
          video.preload = 'metadata';
          video.load();
        };

        const canAutoplay = () => isVisible && !reduceMotion && !document.hidden;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const pauseVideos = () => {
          clearAutoplay();
          root.dataset.tzdFocusPlaying = 'false';
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
        };

        const activate = (requestedIndex) => {
          const previousIndex = activeIndex;
          activeIndex = (requestedIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const selected = index === activeIndex;
            const video = slide.querySelector('video');
            slide.classList.toggle('is-active', selected);
            slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
            slide.setAttribute('tabindex', selected ? '0' : '-1');
            if (!video) return;
            video.controls = reduceMotion;
            if (selected && (isNear || isVisible) && !document.hidden) loadVideo(video);
            if (selected && canAutoplay()) {
              if (previousIndex !== activeIndex) {
                try { video.currentTime = 0; } catch (error) {}
              }
              const playback = video.play();
              if (playback && typeof playback.then === 'function') {
                playback.then(() => {
                  if (signal.aborted || !canAutoplay() || index !== activeIndex) video.pause();
                }).catch(() => {
                  if (!signal.aborted && canAutoplay() && index === activeIndex) video.controls = true;
                });
              }
            } else {
              video.pause();
            }
          });

          metaSlides.forEach((meta, index) => {
            const selected = index === activeIndex;
            meta.classList.toggle('is-active', selected);
            meta.hidden = !selected;
          });

          controls.forEach((control, index) => {
            const selected = index === activeIndex;
            control.classList.toggle('is-active', selected);
            control.setAttribute('aria-pressed', selected ? 'true' : 'false');
            if (!selected) return;
            const progress = control.querySelector('span');
            if (!progress) return;
            progress.style.animation = 'none';
            void progress.offsetWidth;
            progress.style.animation = '';
          });
        };

        const scheduleAutoplay = () => {
          clearAutoplay();
          const playing = canAutoplay() && slides.length > 1;
          root.dataset.tzdFocusPlaying = playing ? 'true' : 'false';
          if (!playing) return;
          timer = window.setTimeout(() => {
            activate(activeIndex + 1);
            scheduleAutoplay();
          }, focusAutoplayDuration);
        };

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            activate(Number(control.dataset.index));
            scheduleAutoplay();
          }, { signal });
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pauseVideos();
            return;
          }
          activate(activeIndex);
          scheduleAutoplay();
        }, { signal });

        motionPreference.addEventListener('change', () => {
          reduceMotion = motionPreference.matches;
          activate(activeIndex);
          scheduleAutoplay();
        }, { signal });

        if ('IntersectionObserver' in window) {
          nearObserver = new IntersectionObserver((entries) => {
            isNear = entries.some((entry) => entry.isIntersecting);
            if (isNear && !document.hidden) loadVideo(slides[activeIndex].querySelector('video'));
          }, { rootMargin: '200px 0px' });
          visibleObserver = new IntersectionObserver((entries) => {
            isVisible = entries.some((entry) => entry.isIntersecting);
            if (!isVisible) {
              pauseVideos();
              return;
            }
            activate(activeIndex);
            scheduleAutoplay();
          });
          nearObserver.observe(media);
          visibleObserver.observe(media);
        }

        activate(0);
        scheduleAutoplay();

        root.tzdFocusCleanup = () => {
          pauseVideos();
          if (nearObserver) nearObserver.disconnect();
          if (visibleObserver) visibleObserver.disconnect();
          controller.abort();
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
          root.removeAttribute('data-tzd-focus-ready');
          root.removeAttribute('data-tzd-focus-playing');
          delete root.tzdFocusCleanup;
        };
      });
    };

    const initialize = (scope) => {
      initializeFocusCarousels(scope);
      scope.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.dataset.tzdTabsReady === 'true') return;
        const tabs = Array.from(root.querySelectorAll('[data-tzd-system-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-tzd-system-panel]'));
        const tablist = root.querySelector('[role="tablist"]');
        if (tabs.length === 0 || !tablist) return;

        root.dataset.tzdTabsReady = 'true';
        root.classList.add('is-tabs-enhanced');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let timer = 0;
        let isUserPaused = false;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const centerTab = (tab, behavior) => {
          const maxScroll = Math.max(0, tablist.scrollWidth - tablist.clientWidth);
          if (maxScroll === 0) return;
          const listRect = tablist.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          const target = tablist.scrollLeft + tabRect.left - listRect.left - (tablist.clientWidth - tabRect.width) / 2;
          tablist.scrollTo({
            left: Math.max(0, Math.min(maxScroll, target)),
            behavior
          });
        };

        const autoplayIsPaused = () => (
          reduceMotion
          || tabs.length < 2
          || isUserPaused
          || document.hidden
        );

        let scheduleAutoplay;

        const activate = (tab, moveFocus, restartAutoplay) => {
          const panelId = tab.getAttribute('aria-controls');
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.setAttribute('tabindex', selected ? '0' : '-1');
          });
          panels.forEach((panel) => {
            const selected = panel.id === panelId;
            panel.classList.toggle('is-active', selected);
            panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
            const link = panel.querySelector('a');
            if (link) link.setAttribute('tabindex', selected ? '0' : '-1');
          });
          centerTab(tab, reduceMotion ? 'auto' : 'smooth');
          if (moveFocus) tab.focus({ preventScroll: true });
          if (restartAutoplay) scheduleAutoplay();
        };

        scheduleAutoplay = () => {
          clearAutoplay();
          tabs.forEach((tab) => tab.classList.remove('is-progressing'));
          const paused = autoplayIsPaused();
          root.classList.toggle('is-autoplay-paused', paused);
          if (paused) return;

          const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
          void activeTab.offsetWidth;
          activeTab.classList.add('is-progressing');
          timer = window.setTimeout(() => {
            const currentIndex = tabs.indexOf(activeTab);
            const nextTab = tabs[(currentIndex + 1) % tabs.length];
            activate(nextTab, false, false);
            scheduleAutoplay();
          }, autoplayDuration);
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            isUserPaused = true;
            activate(tab, false, true);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === index) return;
            event.preventDefault();
            isUserPaused = true;
            activate(tabs[nextIndex], true, true);
          }, { signal });
        });

        document.addEventListener('visibilitychange', scheduleAutoplay, { signal });
        scheduleAutoplay();

        root.tzdTabsCleanup = () => {
          clearAutoplay();
          controller.abort();
          root.classList.remove('is-tabs-enhanced', 'is-autoplay-paused');
          root.removeAttribute('data-tzd-tabs-ready');
          delete root.tzdTabsCleanup;
        };
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.tzdFocusCleanup) root.tzdFocusCleanup();
      });
      event.target.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.tzdTabsCleanup) root.tzdTabsCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-confidence-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const openedItem = event.target;
    if (!openedItem.matches('.ss26-golf-faq__item') || !openedItem.open) return;

    const list = openedItem.closest('.ss26-golf-faq__list');
    if (!list) return;
    list.querySelectorAll('.ss26-golf-faq__item[open]').forEach((item) => {
      if (item !== openedItem) item.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-gift-promotion"]) return;
  try {
    
  document.querySelectorAll('[data-ss26-gift-promotion-source]').forEach((source) => {
    if (source.dataset.initialized === 'true') return;
    source.dataset.initialized = 'true';

    const endAt = source.dataset.campaignEndAt;
    if (endAt && Date.now() > Date.parse(endAt)) {
      source.remove();
      return;
    }

    const offer = source.querySelector('[data-ss26-gift-offer]');
    const blocks = document.querySelector('.product-single__meta [data-product-blocks]');
    const buyBlock = Array.from(blocks?.children || []).find((block) =>
      block.querySelector('form[action*="/cart/add"]')
    );

    if (offer && buyBlock) {
      buyBlock.after(offer);
      source.remove();
    } else {
      source.hidden = false;
    }

    offer?.addEventListener('toggle', () => {
      if (!offer.open || !Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({ event: 'ss26_gift_offer_open' });
    });

    offer?.addEventListener('click', (event) => {
      const tier = event.target.closest('[data-ss26-gift-tier]');
      const collectionCta = event.target.closest('[data-ss26-gift-collection-cta]');
      if (!tier && !collectionCta) return;
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: 'ss26_gift_cta_click',
        gift_tier: tier?.dataset.ss26GiftTier || 'collection'
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-pdp-tuning"]) return;
  try {
    
  document.querySelectorAll('[data-ss26-golf-pdp-source]').forEach((source) => {
    if (source.dataset.initialized === 'true') return;

    const meta = document.querySelector('.product-single__meta');
    const blocks = meta?.querySelector('[data-product-blocks]');
    const header = meta?.querySelector('.product-block--header');
    const price = blocks?.querySelector(':scope > .product-block--price');

    if (!meta || !blocks || !header || !price || meta.dataset.ss26Enhanced === 'true') return;

    source.dataset.initialized = 'true';
    meta.dataset.ss26Enhanced = 'true';

    const kicker = source.querySelector('[data-ss26-pdp-kicker]');
    const subheading = source.querySelector('[data-ss26-pdp-subheading]');
    const fit = source.querySelector('[data-ss26-pdp-fit]');
    const returnItem = source.querySelector('[data-ss26-pdp-return]');
    const mediaCount = source.querySelector('[data-ss26-media-count]');
    const fathersDayDiscount = source.querySelector('[data-ss26-fathers-day-discount]');
    const fathersDayPricing = source.querySelector('[data-ss26-fathers-day-pricing]');

    document.documentElement.style.setProperty(
      '--ss26-pdp-media-ratio',
      source.dataset.mobileMediaRatio || '3 / 4'
    );

    const title = header.querySelector('.product-single__title');
    if (title && source.dataset.displayTitle) { title.setAttribute('translate', 'no'); title.textContent = source.dataset.displayTitle; }

    if (kicker) header.before(kicker);

    const titleRow = document.createElement('div');
    titleRow.className = 'ss26-golf-pdp-title-row';
    header.before(titleRow);
    titleRow.append(header, price);

    if (fathersDayPricing) {
      price.classList.add('ss26-fathers-day-price-active');
      price.append(fathersDayPricing);

      let eligibleVariantIds = new Set();
      const variantJson = meta.querySelector('[data-variant-json]');
      if (variantJson) {
        try {
          eligibleVariantIds = new Set(
            JSON.parse(variantJson.textContent || '[]').map((variant) => String(variant.id))
          );
        } catch (error) {
          eligibleVariantIds = new Set();
        }
      }

      const formatMoney = (cents) => {
        if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
          return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
        }

        return new Intl.NumberFormat('zh-TW', {
          style: 'currency',
          currency: 'TWD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      };

      const updateFathersDayPrice = (variant) => {
        if (!variant || (eligibleVariantIds.size && !eligibleVariantIds.has(String(variant.id)))) return;

        const originalPrice = Number(variant.price);
        if (!Number.isFinite(originalPrice)) return;

        const discountedPrice = Math.round(originalPrice * 0.88);
        const discountedPriceElement = fathersDayPricing.querySelector('[data-ss26-fathers-day-price]');
        const originalPriceElement = fathersDayPricing.querySelector('[data-ss26-fathers-day-original-price]');

        const renderMoney = (element, cents) => {
          if (!element) return;

          const decoder = document.createElement('textarea');
          decoder.innerHTML = String(formatMoney(cents));
          const decoded = decoder.value;

          const template = document.createElement('template');
          template.innerHTML = decoded;
          const formattedText = (
            template.content.querySelector('.langwill-money')?.textContent ||
            template.content.textContent ||
            decoded
          ).trim();

          element.setAttribute('translate', 'no');
          element.classList.add('notranslate');
          element.textContent = formattedText;
        };

        renderMoney(discountedPriceElement, discountedPrice);
        renderMoney(originalPriceElement, originalPrice);
      };

      document.addEventListener('variant:change', (event) => {
        updateFathersDayPrice(event.detail?.variant);
      });
    }

    if (fathersDayDiscount) titleRow.after(fathersDayDiscount);
    if (subheading) (fathersDayDiscount || titleRow).after(subheading);

    const salesPoints = Array.from(blocks.children).filter((block) =>
      block.classList.contains('product-block--sales-point')
    );
    const benefitPoints = salesPoints.slice(0, 3);
    const servicePoints = salesPoints.slice(3);
    const variantBlock = Array.from(blocks.children).find((block) =>
      block.hasAttribute('data-dynamic-variants-enabled')
    );

    if (benefitPoints.length && variantBlock) {
      const proofGrid = document.createElement('div');
      proofGrid.className = 'ss26-golf-pdp-proof-grid';
      variantBlock.before(proofGrid);
      benefitPoints.forEach((point) => proofGrid.append(point));
    }

    const sizeWrapper = Array.from(meta.querySelectorAll('.variant-wrapper')).find((wrapper) => {
      const label = wrapper.querySelector('.variant__label')?.textContent || '';
      return /尺寸|size/i.test(label);
    });

    if (fit && variantBlock && sizeWrapper) {
      fit.hidden = false;
      variantBlock.after(fit);

      fit.querySelector('[data-ss26-size-guide]')?.addEventListener('click', () => {
        const sizeTrigger = Array.from(meta.querySelectorAll('.collapsible-trigger')).find((trigger) =>
          /尺寸|^\s*size\s+guide\s*$/i.test(trigger.textContent || '')
        );
        if (!sizeTrigger) return;
        if (sizeTrigger.getAttribute('aria-expanded') !== 'true') sizeTrigger.click();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sizeTrigger.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    const dispatchPoint = servicePoints.find((point) => /出貨|工作天/.test(point.textContent || ''));
    const shippingPoint = servicePoints.find((point) => point !== dispatchPoint);
    const trustGrid = document.createElement('div');
    trustGrid.className = 'ss26-golf-pdp-trust-grid';
    if (dispatchPoint) trustGrid.append(dispatchPoint);
    if (returnItem) trustGrid.append(returnItem);

    const fitAnchor = fit && !fit.hidden ? fit : variantBlock;
    if (trustGrid.children.length && fitAnchor) fitAnchor.after(trustGrid);

    if (shippingPoint) {
      shippingPoint.classList.add('ss26-golf-pdp-shipping-note');
      trustGrid.after(shippingPoint);
    }

    const buyBlock = Array.from(blocks.children).find((block) =>
      block.querySelector('form[action*="/cart/add"]')
    );
    const purchaseAnchor = shippingPoint || (trustGrid.children.length ? trustGrid : fitAnchor);
    if (buyBlock && purchaseAnchor) purchaseAnchor.after(buyBlock);

    const gallery = document.querySelector('.product__main-photos');
    const slides = gallery ? Array.from(gallery.querySelectorAll('.product-main-slide')) : [];
    if (gallery && mediaCount && slides.length) {
      gallery.append(mediaCount);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const videoSlides = slides.filter((slide) => slide.querySelector('.product__video-wrapper'));

      videoSlides.forEach((slide) => {
        slide.classList.add('ss26-golf-video-slide');
        const video = slide.querySelector('.product__video-wrapper video');
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
      });

      const videoThumbs = videoSlides
        .map((slide) => {
          const mediaId = slide.dataset.mediaId;
          const thumb = mediaId ? document.querySelector(`[data-product-thumb][data-id="${mediaId}"]`) : null;
          return thumb ? { thumb, slide } : null;
        })
        .filter(Boolean);

      videoThumbs.forEach(({ thumb, slide }) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          thumb.blur();
          thumb.focus({ preventScroll: true });

          const video = slide.querySelector('.product__video-wrapper video');
          if (!video || reducedMotion.matches) return;
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        });
      });

      let initialIndex = 0;
      let counterReady = false;
      const updateMediaCount = () => {
        if (!counterReady) {
          mediaCount.textContent = `1 / ${slides.length}`;
          return;
        }
        const selected = slides.find((slide) => slide.classList.contains('is-selected')) || slides[0];
        const selectedIndex = ((slides.indexOf(selected) - initialIndex + slides.length) % slides.length) + 1;
        mediaCount.textContent = `${selectedIndex} / ${slides.length}`;
      };

      const syncActiveVideo = () => {
        videoSlides.forEach((slide) => {
          const video = slide.querySelector('.product__video-wrapper video');
          if (!video) return;

          if (slide.classList.contains('is-selected') && !reducedMotion.matches && !document.hidden) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const updateGalleryState = () => {
        updateMediaCount();
        window.requestAnimationFrame(syncActiveVideo);
      };

      updateGalleryState();
      const mediaObserver = new MutationObserver(updateGalleryState);
      slides.forEach((slide) => mediaObserver.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      document.addEventListener('visibilitychange', syncActiveVideo);
      reducedMotion.addEventListener('change', syncActiveVideo);
      window.setTimeout(() => {
        const settledSlide = slides.find((slide) => slide.classList.contains('is-selected')) || slides[0];
        initialIndex = slides.indexOf(settledSlide);
        counterReady = true;
        updateGalleryState();
      }, 500);
    }
  });

  const hideInfiniteSliderClonesFromAssistiveTech = () => {
    document.querySelectorAll('[class*="ai-infinite-slider-track-"]').forEach((track) => {
      const originalCards = new Set();

      Array.from(track.children).forEach((card) => {
        const title = card.querySelector('h1, h2, h3, h4, h5, h6')?.textContent?.trim() || '';
        const image = card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '';
        const key = `${title}|${image}`;

        if (!title && !image) return;

        track.setAttribute('role', 'list');

        if (!originalCards.has(key)) {
          originalCards.add(key);
          card.removeAttribute('aria-hidden');
          card.removeAttribute('inert');
          card.setAttribute('role', 'listitem');
          return;
        }

        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('role', 'presentation');
        card.setAttribute('inert', '');
        card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
          control.setAttribute('tabindex', '-1');
          control.setAttribute('aria-hidden', 'true');
        });
      });
    });
  };

  const scheduleInfiniteSliderAccessibilitySync = () => {
    hideInfiniteSliderClonesFromAssistiveTech();
    window.setTimeout(hideInfiniteSliderClonesFromAssistiveTech, 500);
    window.setTimeout(hideInfiniteSliderClonesFromAssistiveTech, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInfiniteSliderAccessibilitySync, { once: true });
  } else {
    scheduleInfiniteSliderAccessibilitySync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-sticky-purchase"]) return;
  try {
    
  if (!customElements.get('ss26-golf-sticky-atc')) {
    customElements.define(
      'ss26-golf-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-sticky-button]');
          this.selection = this.querySelector('[data-sticky-selection]');
          this.price = this.querySelector('[data-sticky-price]');
          this.meta = document.querySelector('.product-single__meta');
          this.form = this.meta?.querySelector('form[action*="/cart/add"]');
          this.originalButton = this.form?.querySelector('button[name="add"], button[type="submit"]');
          this.priceSource = this.meta?.querySelector('[data-product-price]');
          this.hasSize = this.dataset.hasSize === 'true';
          this.directAdd = this.dataset.directAdd === 'true';

          this.sizeWrapper = Array.from(this.meta?.querySelectorAll('.variant-wrapper') || []).find((wrapper) => {
            const label = wrapper.querySelector('.variant__label')?.textContent || '';
            return /尺寸|size/i.test(label);
          });
          this.optionTarget = this.sizeWrapper || this.meta?.querySelector('.variant-wrapper.js, .variant-input-wrap');

          if (!this.button || !this.form || !this.originalButton) return;

          this.button.addEventListener('click', () => this.handleClick());
          this.meta.addEventListener('change', (event) => this.handleOptionChange(event));

          if ('MutationObserver' in window) {
            if (this.priceSource) {
              this.priceObserver = new MutationObserver(() => this.updateUI());
              this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
            }
            this.buttonObserver = new MutationObserver(() => this.updateUI());
            this.buttonObserver.observe(this.originalButton, {
              attributes: true,
              attributeFilter: ['disabled', 'aria-disabled', 'class']
            });
          }

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.setVisible(!entries[0].isIntersecting);
            });
            this.observer.observe(this.originalButton);
          } else {
            this.setVisible(true);
          }

          this.updateUI();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.priceObserver?.disconnect();
          this.buttonObserver?.disconnect();
          this.setVisible(false);
        }

        setVisible(visible) {
          this.classList.toggle('is-visible', visible);
          document.body?.classList.toggle('ss26-sticky-atc-visible', visible);
        }

        handleOptionChange(event) {
          const changedWrapper = event.target.closest('.variant-wrapper');
          if (!changedWrapper) return;

          window.setTimeout(() => this.updateUI(), 50);
        }

        updateUI() {
          const unavailable =
            this.dataset.available !== 'true' ||
            this.originalButton?.matches('[disabled], [aria-disabled="true"], .disabled');
          const selectedSize = this.sizeWrapper?.querySelector('input:checked')?.value;
          const selectedOption = this.optionTarget?.querySelector('input:checked')?.value;

          if (this.priceSource && this.price) {
            this.price.textContent = this.priceSource.textContent.trim();
          }

          if (unavailable) {
            this.button.disabled = true;
            this.button.textContent = this.dataset.soldLabel;
            return;
          }

          this.button.disabled = false;

          if (this.directAdd) {
            this.selection.textContent = this.dataset.readyLabel;
            this.button.textContent = this.dataset.addLabel;
            return;
          }

          if (this.hasSize) {
            this.selection.textContent = selectedSize ? `${this.dataset.selectedLabel} ${selectedSize}` : this.dataset.chooseSizeLabel;
            this.button.textContent = selectedSize ? this.dataset.addLabel : this.dataset.sizeLabel;
            return;
          }

          this.selection.textContent = selectedOption ? `${this.dataset.selectedLabel} ${selectedOption}` : this.dataset.chooseOptionLabel;
          this.button.textContent = selectedOption ? this.dataset.addLabel : this.dataset.optionLabel;
        }

        handleClick() {
          if (
            this.dataset.available !== 'true' ||
            this.originalButton.matches('[disabled], [aria-disabled="true"], .disabled')
          ) return;

          const selectedSize = this.sizeWrapper?.querySelector('input:checked')?.value;
          const selectedOption = this.optionTarget?.querySelector('input:checked')?.value;
          const hasResolvedSelection = this.directAdd || (this.hasSize ? selectedSize : selectedOption);

          if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
              event: 'ss26_sticky_atc_click',
              product_handle: this.dataset.productHandle,
              selection_required: !hasResolvedSelection
            });
          }

          if (hasResolvedSelection) {
            this.originalButton.click();
            return;
          }

          const target = this.optionTarget || this.originalButton;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });

          const focusable =
            target.querySelector?.('button:not([disabled]), input:not([disabled]), select:not([disabled])') || target;
          focusable.focus?.({ preventScroll: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
